/* ASC-CUSTOM (2026-09-28): crossword frame designer for /pages/family-name-crossword-generator
   (sections/asc-crossword-tool.liquid). Murat's brief: a realistic preview of the real frame (black / walnut / white
   frame, five backgrounds, title, subtitle, letter tiles with values, SCORE line), a fast layout that uses the biggest
   tile that fits, a PDF download with the ASC Gifts logo and watermark, and add to cart with everything the workshop
   needs. Geometry in millimetres from Murat's drawing: 250 mm frame, 30 mm border, 190 mm window; title top 8.22 mm
   below the window edge, 4.05 mm title-subtitle gap, 150.46 mm tile band, 11.21 mm under the SCORE line.
   Part 1 is a pure engine (node runs it for tests); part 2 draws; part 3 wires the page. Nothing is sent anywhere
   except the cart add the customer asks for. */
(function (root) {
  'use strict';

  /* ---------------- 1. Engine ---------------- */
  var VALUES = { A: 1, B: 3, C: 3, D: 2, E: 1, F: 4, G: 2, H: 4, I: 1, J: 8, K: 5, L: 1, M: 3, N: 1, O: 1, P: 3, Q: 10, R: 1, S: 1, T: 1, U: 1, V: 4, W: 4, X: 8, Y: 4, Z: 10 };
  /* 2026-09-29 (Murat, French and German orders): accented letters are tiles of their own (JOSÉ, ZOË, SØREN, ŁUKASZ)
     and cross only the same accented letter, never the plain one. Only ligatures and the sharp s still become plain
     letters. A tile's value is its plain letter's value (É = E = 1). LEGACY_FOLD is the A-Z rule of design links made
     before this (v1), so an order placed then still reopens exactly as it was ordered. */
  var FOLD = { 'Æ': 'AE', 'æ': 'AE', 'Œ': 'OE', 'œ': 'OE', 'Þ': 'TH', 'þ': 'TH', 'ß': 'SS', 'ẞ': 'SS', 'ı': 'I' };
  var LEGACY_FOLD = { 'Ø': 'O', 'ø': 'O', 'Æ': 'AE', 'æ': 'AE', 'Œ': 'OE', 'œ': 'OE', 'Ł': 'L', 'ł': 'L', 'Đ': 'D', 'đ': 'D', 'Þ': 'TH', 'þ': 'TH', 'ß': 'SS', 'ı': 'I' };
  var BASE_OF = { 'Ø': 'O', 'Ł': 'L', 'Đ': 'D', 'Ð': 'D', 'Ħ': 'H', 'Ŧ': 'T', 'Ŀ': 'L', 'Ŋ': 'N' };
  var TILE_LETTER = /^[A-ZÀ-ÖØ-ÝĀ-ž]$/;
  var valueCache = {};
  function tileValue(ch) {
    if (VALUES[ch]) return VALUES[ch];
    if (valueCache[ch] === undefined) {
      var b = BASE_OF[ch] || (ch.normalize ? ch.normalize('NFD').charAt(0) : ch);
      valueCache[ch] = VALUES[b] || 0;
    }
    return valueCache[ch];
  }
  /* 2026-09-28 (Murat): the outer size is the 247 mm backboard; window and inner measurements unchanged (28.5 mm border). */
  var GEO = { outer: 247, rail: 12.5, mat: 16, win: 190, titleTop: 8.22, titleCap: 8.36, gap: 4.05, subCap: 3.85, band: 150.46, scoreCap: 3.85, bottom: 11.21,
              padX: 10, padY: 6, pitchMax: 20, gapRatio: 0.085 };
  /* Symbols for the title and subtitle (Phosphor Icons, MIT licence, 256-unit grid; "fill" weight, infinity and snowflake "bold" because their fill versions sit in a solid box). c = the character the
     text field shows; the preview, PDF and workshop SVG draw the vector path instead. */
  var ICONS = [
    { k: 'heart', n: 'Heart', c: '\u2665', d: 'M240,102c0,70-103.79,126.66-108.21,129a8,8,0,0,1-7.58,0C119.79,228.66,16,172,16,102A62.07,62.07,0,0,1,78,40c20.65,0,38.73,8.88,50,23.89C139.27,48.88,157.35,40,178,40A62.07,62.07,0,0,1,240,102Z' },
    { k: 'star', n: 'Star', c: '\u2605', d: 'M234.29,114.85l-45,38.83L203,211.75a16.4,16.4,0,0,1-24.5,17.82L128,198.49,77.47,229.57A16.4,16.4,0,0,1,53,211.75l13.76-58.07-45-38.83A16.46,16.46,0,0,1,31.08,86l59-4.76,22.76-55.08a16.36,16.36,0,0,1,30.27,0l22.75,55.08,59,4.76a16.46,16.46,0,0,1,9.37,28.86Z' },
    { k: 'paw-print', n: 'Paw print', c: '\uD83D\uDC3E', d: 'M240,108a28,28,0,1,1-28-28A28,28,0,0,1,240,108ZM72,108a28,28,0,1,0-28,28A28,28,0,0,0,72,108ZM92,88A28,28,0,1,0,64,60,28,28,0,0,0,92,88Zm72,0a28,28,0,1,0-28-28A28,28,0,0,0,164,88Zm23.12,60.86a35.3,35.3,0,0,1-16.87-21.14,44,44,0,0,0-84.5,0A35.25,35.25,0,0,1,69,148.82,40,40,0,0,0,88,224a39.48,39.48,0,0,0,15.52-3.13,64.09,64.09,0,0,1,48.87,0,40,40,0,0,0,34.73-72Z' },
    { k: 'dog', n: 'Dog', c: '\uD83D\uDC36', d: 'M239.71,125l-16.42-88a16,16,0,0,0-19.61-12.58l-.31.09L150.85,40h-45.7L52.63,24.56l-.31-.09A16,16,0,0,0,32.71,37.05L16.29,125a15.77,15.77,0,0,0,9.12,17.52A16.26,16.26,0,0,0,32.12,144,15.48,15.48,0,0,0,40,141.84V184a40,40,0,0,0,40,40h96a40,40,0,0,0,40-40V141.85a15.5,15.5,0,0,0,7.87,2.16,16.31,16.31,0,0,0,6.72-1.47A15.77,15.77,0,0,0,239.71,125ZM176,208H136V195.31l13.66-13.65a8,8,0,0,0-11.32-11.32L128,180.69l-10.34-10.35a8,8,0,0,0-11.32,11.32L120,195.31V208H80a24,24,0,0,1-24-24V123.11L107.93,56h40.14L200,123.11V184A24,24,0,0,1,176,208Zm-72-68a12,12,0,1,1-12-12A12,12,0,0,1,104,140Zm72,0a12,12,0,1,1-12-12A12,12,0,0,1,176,140Z' },
    { k: 'cat', n: 'Cat', c: '\uD83D\uDC31', d: 'M222.83,33.54a16,16,0,0,0-18.14,3.15c-.14.14-.26.27-.38.41L187.05,57A111.28,111.28,0,0,0,69,57L51.69,37.1c-.12-.14-.24-.27-.38-.41a16,16,0,0,0-18.14-3.15A16.4,16.4,0,0,0,24,48.46V136c0,49,40.06,89.63,91.56,95.32a4,4,0,0,0,4.44-4v-32l-13.42-13.43a8.22,8.22,0,0,1-.41-11.37,8,8,0,0,1,11.49-.18L128,180.68l10.34-10.35a8,8,0,0,1,11.49.18,8.22,8.22,0,0,1-.41,11.37L136,195.31v32a4,4,0,0,0,4.44,4C191.94,225.62,232,185,232,136V48.46A16.4,16.4,0,0,0,222.83,33.54ZM84,152a12,12,0,1,1,12-12A12,12,0,0,1,84,152Zm20-64a8,8,0,1,1-16,0V69a8,8,0,0,1,16,0Zm32,0a8,8,0,1,1-16,0V64a8,8,0,0,1,16,0Zm16,0V69a8,8,0,0,1,16,0V88a8,8,0,1,1-16,0Zm20,64a12,12,0,1,1,12-12A12,12,0,0,1,172,152Z' },
    { k: 'house', n: 'House', c: '\uD83C\uDFE0', d: 'M224,120v96a8,8,0,0,1-8,8H160a8,8,0,0,1-8-8V164a4,4,0,0,0-4-4H108a4,4,0,0,0-4,4v52a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V120a16,16,0,0,1,4.69-11.31l80-80a16,16,0,0,1,22.62,0l80,80A16,16,0,0,1,224,120Z' },
    { k: 'tree-evergreen', n: 'Pine tree', c: '\uD83C\uDF32', d: 'M231.19,195.51A8,8,0,0,1,224,200H136v40a8,8,0,0,1-16,0V200H32a8,8,0,0,1-6.31-12.91l46-59.09H48a8,8,0,0,1-6.34-12.88l80-104a8,8,0,0,1,12.68,0l80,104A8,8,0,0,1,208,128H184.36l45.95,59.09A8,8,0,0,1,231.19,195.51Z' },
    { k: 'leaf', n: 'Leaf', c: '\uD83C\uDF3F', d: 'M223.45,40.07a8,8,0,0,0-7.52-7.52C139.8,28.08,78.82,51,52.82,94a87.09,87.09,0,0,0-12.76,49A101.72,101.72,0,0,0,46.7,175.2a4,4,0,0,0,6.61,1.43l85-86.3a8,8,0,0,1,11.32,11.32L56.74,195.94,42.55,210.13a8.2,8.2,0,0,0-.6,11.1,8,8,0,0,0,11.71.43l16.79-16.79c14.14,6.84,28.41,10.57,42.56,11.07q1.67.06,3.33.06A86.93,86.93,0,0,0,162,203.18C205,177.18,227.93,116.21,223.45,40.07Z' },
    { k: 'flower', n: 'Flower', c: '\u273F', d: 'M210.35,129.36c-.81-.47-1.7-.92-2.62-1.36.92-.44,1.81-.89,2.62-1.36a40,40,0,1,0-40-69.28c-.81.47-1.65,1-2.48,1.59.08-1,.13-2,.13-3a40,40,0,0,0-80,0c0,.94,0,1.94.13,3-.83-.57-1.67-1.12-2.48-1.59a40,40,0,1,0-40,69.28c.81.47,1.7.92,2.62,1.36-.92.44-1.81.89-2.62,1.36a40,40,0,1,0,40,69.28c.81-.47,1.65-1,2.48-1.59-.08,1-.13,2-.13,2.95a40,40,0,0,0,80,0c0-.94-.05-1.94-.13-2.95.83.57,1.67,1.12,2.48,1.59A39.79,39.79,0,0,0,190.29,204a40.43,40.43,0,0,0,10.42-1.38,40,40,0,0,0,9.64-73.28ZM128,156a28,28,0,1,1,28-28A28,28,0,0,1,128,156Z' },
    { k: 'sun', n: 'Sun', c: '\u2600', d: 'M120,40V16a8,8,0,0,1,16,0V40a8,8,0,0,1-16,0Zm8,24a64,64,0,1,0,64,64A64.07,64.07,0,0,0,128,64ZM58.34,69.66A8,8,0,0,0,69.66,58.34l-16-16A8,8,0,0,0,42.34,53.66Zm0,116.68-16,16a8,8,0,0,0,11.32,11.32l16-16a8,8,0,0,0-11.32-11.32ZM192,72a8,8,0,0,0,5.66-2.34l16-16a8,8,0,0,0-11.32-11.32l-16,16A8,8,0,0,0,192,72Zm5.66,114.34a8,8,0,0,0-11.32,11.32l16,16a8,8,0,0,0,11.32-11.32ZM48,128a8,8,0,0,0-8-8H16a8,8,0,0,0,0,16H40A8,8,0,0,0,48,128Zm80,80a8,8,0,0,0-8,8v24a8,8,0,0,0,16,0V216A8,8,0,0,0,128,208Zm112-88H216a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16Z' },
    { k: 'moon', n: 'Moon', c: '\u263E', d: 'M235.54,150.21a104.84,104.84,0,0,1-37,52.91A104,104,0,0,1,32,120,103.09,103.09,0,0,1,52.88,57.48a104.84,104.84,0,0,1,52.91-37,8,8,0,0,1,10,10,88.08,88.08,0,0,0,109.8,109.8,8,8,0,0,1,10,10Z' },
    { k: 'infinity', n: 'Infinity', c: '\u221E', d: 'M252,128a60,60,0,0,1-102.43,42.43l-.49-.53L89.22,102.31a36,36,0,1,0,0,51.38l3.08-3.48a12,12,0,1,1,18,15.91l-3.35,3.78-.49.53a60,60,0,1,1,0-84.86l.49.53,59.86,67.59a36,36,0,1,0,0-51.38l-3.08,3.48a12,12,0,1,1-18-15.91l3.35-3.78.49-.53A60,60,0,0,1,252,128Z' },
    { k: 'cross', n: 'Cross', c: '\u271D', d: 'M216,92v24a16,16,0,0,1-16,16H156v92a16,16,0,0,1-16,16H116a16,16,0,0,1-16-16V132H56a16,16,0,0,1-16-16V92A16,16,0,0,1,56,76h44V32a16,16,0,0,1,16-16h24a16,16,0,0,1,16,16V76h44A16,16,0,0,1,216,92Z' },
    { k: 'anchor', n: 'Anchor', c: '\u2693', d: 'M224,144c0,38.11-27.67,45.66-49.9,51.72C149.77,202.36,136,207.31,136,232a8,8,0,0,1-16,0c0-24.69-13.77-29.64-38.1-36.28C59.67,189.66,32,182.11,32,144a8,8,0,0,1,16,0c0,24.69,13.77,29.64,38.1,36.28,11.36,3.1,24.12,6.6,33.9,14.34V128H88a8,8,0,0,1,0-16h32V82.83a28,28,0,1,1,16,0V112h32a8,8,0,0,1,0,16H136v66.62c9.78-7.74,22.54-11.24,33.9-14.34C194.23,173.64,208,168.69,208,144a8,8,0,0,1,16,0Z' },
    { k: 'snowflake', n: 'Snowflake', c: '\u2744', d: 'M227.65,149.14a12,12,0,0,1-8.79,14.51l-20.67,5.08,5.4,20.16a12,12,0,0,1-23.18,6.22l-7.29-27.2L140,148.78V187l20.48,20.48a12,12,0,0,1-17,17L128,209l-15.51,15.52a12,12,0,0,1-17-17L116,187V148.78L82.88,167.91l-7.29,27.2a12,12,0,0,1-23.18-6.22l5.4-20.16-20.67-5.08a12,12,0,1,1,5.72-23.3l27.89,6.85L104,128,70.75,108.8l-27.89,6.85A11.8,11.8,0,0,1,40,116a12,12,0,0,1-2.85-23.65l20.67-5.08-5.4-20.16a12,12,0,0,1,23.18-6.22l7.29,27.2L116,107.21V69L95.52,48.48a12,12,0,0,1,17-17L128,47l15.51-15.52a12,12,0,1,1,17,17L140,69v38.24l33.12-19.12,7.29-27.2a12,12,0,0,1,23.18,6.22l-5.4,20.16,20.67,5.08A12,12,0,0,1,216,116a11.8,11.8,0,0,1-2.87-.35l-27.89-6.85L152,128l33.25,19.2,27.89-6.85A12,12,0,0,1,227.65,149.14Z' },
    { k: 'music-note', n: 'Music note', c: '\u266A', d: 'M210.3,56.34l-80-24A8,8,0,0,0,120,40V148.26A48,48,0,1,0,136,184V98.75l69.7,20.91A8,8,0,0,0,216,112V64A8,8,0,0,0,210.3,56.34Z' },
    { k: 'bird', n: 'Bird', c: '\uD83D\uDD4A', d: 'M236.44,73.34,213.21,57.86A60,60,0,0,0,156,16h-.29C122.79,16.16,96,43.47,96,76.89V96.63L11.63,197.88l-.1.12A16,16,0,0,0,24,224h88A104.11,104.11,0,0,0,216,120V100.28l20.44-13.62a8,8,0,0,0,0-13.32ZM126.15,133.12l-60,72a8,8,0,1,1-12.29-10.24l60-72a8,8,0,1,1,12.29,10.24ZM164,80a12,12,0,1,1,12-12A12,12,0,0,1,164,80Z' },
    { k: 'butterfly', n: 'Butterfly', c: '\uD83E\uDD8B', d: 'M128,100.17a108.42,108.42,0,0,0-8-12.64V56a8,8,0,0,1,16,0V87.53A108.42,108.42,0,0,0,128,100.17ZM232.7,50.48C229,45.7,221.84,40,209,40c-16.85,0-38.46,11.28-57.81,30.16A140.07,140.07,0,0,0,136,87.53V180a8,8,0,0,1-16,0V87.53a140.07,140.07,0,0,0-15.15-17.37C85.49,51.28,63.88,40,47,40,34.16,40,27,45.7,23.3,50.48c-6.82,8.77-12.18,24.08-.21,71.2,6.05,23.83,19.51,33,30.63,36.42A44,44,0,0,0,128,205.27a44,44,0,0,0,74.28-47.17c11.12-3.4,24.57-12.59,30.63-36.42C239.63,95.24,244.85,66.1,232.7,50.48Z' },
    { k: 'clover', n: 'Clover', c: '\u2618', d: 'M228,120c0,22.63-6,36.72-17.93,41.87a27.3,27.3,0,0,1-11,2.13,41.75,41.75,0,0,1-8.4-.93,4.05,4.05,0,0,1-2.52-1.64,368.49,368.49,0,0,0-47.75-55.26,8,8,0,0,0-11,11.62c14.84,13.91,64.13,63.49,78.32,120.27a8,8,0,0,1-5.82,9.7A8.13,8.13,0,0,1,200,248a8,8,0,0,1-7.75-6.06c-4.12-16.47-11.65-32.48-20.46-47.09a25.85,25.85,0,0,1-1.9,7.21C164.72,214,150.63,220,128,220s-36.72-6-41.88-17.94c-5.45-12.58-.39-30.82,15-54.21.68-1,1.36-2,2-3l-3,2C82.84,158.27,68.35,164,56.89,164a27.3,27.3,0,0,1-11-2.13C34,156.72,28,142.63,28,120s6-36.72,17.93-41.88c12.59-5.45,30.83-.39,54.22,15l3,2q-1-1.5-2-3c-15.41-23.39-20.47-41.63-15-54.22C91.28,26,105.37,20,128,20s36.72,6,41.88,17.93c5.45,12.59.39,30.83-15,54.22q-1,1.53-2,3l3-2c23.39-15.41,41.63-20.47,54.22-15C222,83.28,228,97.37,228,120Z' },
    { k: 'crown', n: 'Crown', c: '\uD83D\uDC51', d: 'M248,80a28,28,0,1,0-51.12,15.77l-26.79,33L146,73.4a28,28,0,1,0-36.06,0L85.91,128.74l-26.79-33a28,28,0,1,0-26.6,12L47,194.63A16,16,0,0,0,62.78,208H193.22A16,16,0,0,0,209,194.63l14.47-86.85A28,28,0,0,0,248,80ZM128,40a12,12,0,1,1-12,12A12,12,0,0,1,128,40ZM24,80A12,12,0,1,1,36,92,12,12,0,0,1,24,80ZM220,92a12,12,0,1,1,12-12A12,12,0,0,1,220,92Z' }
  ];
  var ICON_BY_CHAR = {};
  ICONS.forEach(function (ic) { ICON_BY_CHAR[ic.c] = ic; });
  /* Emoji from phone keyboards map to the nearest engravable symbol (Murat 2026-09-28: people already have emoji). */
  var ICON_ALIASES = {
    'heart': '❤♥♡\u{1F495}\u{1F496}\u{1F497}\u{1F493}\u{1F49E}\u{1F498}\u{1F49D}\u{1F90D}\u{1F5A4}\u{1F90E}\u{1F49B}\u{1F49A}\u{1F499}\u{1F49C}\u{1F9E1}\u{1F48C}\u{1F970}\u{1F60D}',
    'star': '⭐\u{1F31F}✨☆★\u{1F4AB}',
    'paw-print': '\u{1F43E}',
    'dog': '\u{1F415}\u{1F436}\u{1F429}\u{1F9AE}',
    'cat': '\u{1F408}\u{1F431}',
    'house': '\u{1F3E0}\u{1F3E1}\u{1F3D8}⌂',
    'tree-evergreen': '\u{1F332}\u{1F384}',
    'leaf': '\u{1F33F}\u{1F343}\u{1F331}\u{1F342}\u{1F341}',
    'flower': '✿❀\u{1F338}\u{1F33C}\u{1F33A}\u{1F33B}\u{1F337}\u{1F339}\u{1F490}',
    'sun': '☀\u{1F31E}\u{1F324}',
    'moon': '☾☽\u{1F319}\u{1F31B}\u{1F31C}\u{1F31D}',
    'infinity': '∞♾',
    'cross': '✝✞†\u{1F64F}',
    'anchor': '⚓',
    'snowflake': '❄❅❆☃⛄',
    'music-note': '♪♫\u{1F3B5}\u{1F3B6}\u{1F3BC}',
    'bird': '\u{1F54A}\u{1F426}\u{1F424}',
    'butterfly': '\u{1F98B}',
    'clover': '☘\u{1F340}',
    'crown': '\u{1F451}'
  };
  ICONS.forEach(function (ic) {
    Array.from(ICON_ALIASES[ic.k] || '').forEach(function (ch) { if (!ICON_BY_CHAR[ch]) ICON_BY_CHAR[ch] = ic; });
  });
  var TITLE_OK = /^[A-Za-z0-9À-ÖØ-öø-ÿĀ-ſẞ &'’".,!?:;()\-+\/#@*]$/;

  /* Title text -> tokens: {ch} for engraved characters, {icon} for symbols; anything else is dropped and reported. */
  function titleTokens(text) {
    var out = [], dropped = [];
    Array.from(String(text || '').replace(/[︎️‍⃣]|[\u{1F3FB}-\u{1F3FF}]/gu, '')).forEach(function (ch) {
      if (ICON_BY_CHAR[ch]) out.push({ icon: ICON_BY_CHAR[ch] });
      else if (TITLE_OK.test(ch)) out.push({ ch: ch });
      else dropped.push(ch);
    });
    return { tokens: out, dropped: dropped };
  }
  GEO.bandTop = GEO.titleTop + GEO.titleCap + GEO.gap + GEO.subCap;           /* 24.48 */
  GEO.scoreTop = GEO.bandTop + GEO.band;                                     /* 174.94 */
  GEO.areaW = GEO.win - 2 * GEO.padX;                                        /* 170 */
  GEO.areaH = GEO.band - 2 * GEO.padY;                                       /* 138.46 */

  function legacyClean(s) {
    s = String(s || '').replace(/[ØøÆæŒœŁłĐđÞþßı]/g, function (ch) { return LEGACY_FOLD[ch]; });
    if (s.normalize) s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return s.toUpperCase().replace(/[^A-Z]/g, '');
  }

  /* One engraved line in millimetres: font size from the capital height, symbols as a square 1.3 x cap box centred
     on the capitals, letter spacing as a share of the font size, shrunk to maxW when too wide. measure(ch, size)
     returns the advance in mm (canvas or font file), so the preview and the workshop SVG place everything alike. */
  /* every tile once, [row, col, letter], top-left first */
  function tileCells(words, place) {
    var seen = {}, cells = [];
    words.forEach(function (w, i) {
      var pl = place[i]; if (!pl) return;
      for (var j = 0; j < w.length; j++) {
        var r = pl[0] + (pl[2] ? j : 0), c = pl[1] + (pl[2] ? 0 : j), k = r + ',' + c;
        if (seen[k]) continue; seen[k] = 1; cells.push([r, c, w[j]]);
      }
    });
    return cells.sort(function (a, b) { return a[0] - b[0] || a[1] - b[1]; });
  }
  /* where the tile grid sits, in mm from the backboard's top-left corner */
  function gridBox(lay) {
    var p = lay.pitch, t = p * (1 - GEO.gapRatio), gw = lay.cols * p - (p - t), gh = lay.rows * p - (p - t), B = GEO.rail + GEO.mat;
    return { p: p, t: t, x: B + GEO.padX + (GEO.areaW - gw) / 2, y: B + GEO.bandTop + GEO.padY + (GEO.areaH - gh) / 2 };
  }

  var ICON_BOX = 1.3;
  function layoutLine(tokens, measure, capRatioV, o) {
    var size = o.cap / capRatioV, cap = o.cap;
    function adv(t, sz, cp) { return t.icon ? cp * ICON_BOX + sz * 0.12 : measure(t.ch, sz); }
    var total = 0;
    tokens.forEach(function (t, i) { total += adv(t, size, cap) + (i ? o.track * size : 0); });
    if (total > o.maxW) { var k = o.maxW / total; size *= k; cap *= k; total = o.maxW; }
    var x0 = o.cx - total / 2, items = [];
    tokens.forEach(function (t, i) {
      if (i) x0 += o.track * size;
      var a = adv(t, size, cap);
      items.push({ ch: t.ch, icon: t.icon, x: x0, adv: a, box: cap * ICON_BOX });
      x0 += a;
    });
    return { items: items, size: size, capH: cap, base: o.top + o.cap / 2 + cap / 2 };
  }

  /* A typed name -> its tiles (2026-09-29 rule). w: the tile word in capitals, accents kept; folded: a letter became
     other letters (Æ -> AE, ß -> SS, or a mark that has no tile of its own); lost: letters of other alphabets. */
  function tileWord(s) {
    var w = '', folded = false, lost = [];
    s = String(s || '');
    Array.from(s.normalize ? s.normalize('NFC') : s).forEach(function (ch) {
      if (!/\p{L}/u.test(ch)) return;                     /* spaces, hyphens, apostrophes, dots: a name is one word */
      if (FOLD[ch]) { w += FOLD[ch]; folded = true; return; }
      var up = ch.toUpperCase();
      if (up.length === 1 && TILE_LETTER.test(up)) { w += up; return; }
      var plain = (up.normalize ? up.normalize('NFD') : up).replace(/[̀-ͯ]/g, '');
      if (/^[A-Z]+$/.test(plain)) { w += plain; folded = true; return; }
      lost.push(ch);
    });
    return { w: w, folded: folded, lost: lost };
  }

  /* Every change to a typed name is reported to the customer. legacy = the A-Z-only rule of v1 design links. */
  function parseNames(text, max, legacy) {
    var list = [], notes = { merged: [], dup: [], short: [], over: [], folded: [], removed: [], dropped: [], accented: [] };
    String(text || '').split(/[\n,;]+/).forEach(function (raw) {
      var typed = raw.trim().replace(/\s+/g, ' ');
      if (!typed) return;
      var w, letters = typed.replace(/[^\p{L}]/gu, '');
      if (legacy) {
        w = legacyClean(typed);
        if (!w) { if (letters) notes.dropped.push(typed); return; }
        var odd = letters.replace(/[A-Za-z]/g, '');
        if (odd) {
          var lost0 = Array.from(odd).filter(function (ch) { return !legacyClean(ch); });
          if (lost0.length) notes.removed.push({ typed: typed, word: w, chars: lost0.join('') });
          else notes.folded.push({ typed: typed, word: w });
        }
      } else {
        var tw = tileWord(typed); w = tw.w;
        if (!w) { if (letters) notes.dropped.push(typed); return; }
        if (tw.lost.length) notes.removed.push({ typed: typed, word: w, chars: tw.lost.join('') });
        else if (tw.folded) notes.folded.push({ typed: typed, word: w });
        if (/[^A-Z]/.test(w)) notes.accented.push({ typed: typed, word: w });
      }
      if (w.length < 2) { notes.short.push(typed); return; }
      /* the same name twice (John and his son John) stays twice: two words on the board (Murat, 2026-09-28) */
      if (list.length >= max) { notes.over.push(typed); return; }
      if (/[\s'’.-]/.test(typed)) notes.merged.push({ typed: typed, word: w });
      list.push({ typed: typed, word: w });
    });
    return { list: list, notes: notes };
  }

  function wordScore(w) { var s = 0; for (var i = 0; i < w.length; i++) s += tileValue(w[i]); return s; }
  function totalScore(words) { var s = 0; for (var i = 0; i < words.length; i++) s += wordScore(words[i]); return s; }

  function rng(seed) {
    var a = seed >>> 0;
    return function () { a = (a + 0x6D2B79F5) >>> 0; var t = a; t = Math.imul(t ^ (t >>> 15), t | 1); t ^= t + Math.imul(t ^ (t >>> 7), t | 61); return ((t ^ (t >>> 14)) >>> 0) / 4294967296; };
  }

  var N = 112, OFF = 56;

  /* One layout searcher per word list. pass() is a randomised greedy build: every next word crosses a placed word at
     a shared letter, may touch other words only where it crosses them, and takes the spot that keeps the tile pitch
     (the biggest tile the 170 × 138 mm tile area allows) as large as possible. search() repeats it inside a time box
     and keeps the best distinct layouts. */
  function Searcher(words, opt) {
    opt = opt || {};
    this.words = words;
    this.W = opt.W || GEO.areaW; this.H = opt.H || GEO.areaH; this.pitchMax = opt.pitchMax || GEO.pitchMax;
    this.ch = new Uint16Array(N * N); this.fl = new Uint8Array(N * N);   /* char codes: accented letters go past 255 */
    this.best = []; this.keep = opt.keep || 14; this.passes = 0;
  }

  Searcher.prototype.fits = function (w, r, c, d) {
    var L = w.length, dr = d, dc = 1 - d, ch = this.ch, fl = this.fl, bit = d ? 2 : 1, x = 0;
    if (r < 1 || c < 1 || r + dr * L > N - 2 || c + dc * L > N - 2) return -1;
    if (ch[(r - dr) * N + (c - dc)] || ch[(r + dr * L) * N + (c + dc * L)]) return -1;
    for (var i = 0; i < L; i++) {
      var rr = r + dr * i, cc = c + dc * i, k = rr * N + cc, v = ch[k];
      if (v) { if (v !== w.charCodeAt(i) || (fl[k] & bit)) return -1; x++; continue; }
      if (ch[(rr + dc) * N + (cc + dr)] || ch[(rr - dc) * N + (cc - dr)]) return -1;
    }
    return x;
  };

  Searcher.prototype.pass = function (order, rand, jitter, firstDir) {
    var words = this.words, ch = this.ch, fl = this.fl, W = this.W, H = this.H, self = this;
    ch.fill(0); fl.fill(0);
    var lists = {}, NONE = [];                                   /* cells per letter code */
    var pos = [], r0 = 1e9, r1 = -1e9, c0 = 1e9, c1 = -1e9, crosses = 0, tiles = 0;
    function put(wi, r, c, d) {
      var w = words[wi], L = w.length;
      for (var i = 0; i < L; i++) {
        var k = (r + d * i) * N + (c + (1 - d) * i);
        if (!ch[k]) { ch[k] = w.charCodeAt(i); (lists[ch[k]] || (lists[ch[k]] = [])).push(k); tiles++; } else crosses++;
        fl[k] |= d ? 2 : 1;
      }
      pos[wi] = [r, c, d];
      if (r < r0) r0 = r; if (c < c0) c0 = c;
      if (r + d * (L - 1) > r1) r1 = r + d * (L - 1);
      if (c + (1 - d) * (L - 1) > c1) c1 = c + (1 - d) * (L - 1);
    }
    var first = order[0], fl0 = words[first].length;
    if (firstDir) put(first, OFF - (fl0 >> 1), OFF, 1); else put(first, OFF, OFF - (fl0 >> 1), 0);
    var pending = order.slice(1), moved = true;
    while (pending.length && moved) {
      moved = false;
      for (var p = 0; p < pending.length; p++) {
        var wi = pending[p], w = words[wi], L = w.length, best = null, bestS = -1e9;
        for (var j = 0; j < L; j++) {
          var cells = lists[w.charCodeAt(j)] || NONE;
          for (var m = 0; m < cells.length; m++) {
            var k = cells[m], f = fl[k];
            if (f === 3) continue;
            var d = (f & 1) ? 1 : 0, cr = (k / N) | 0, cc = k % N;
            var r = d ? cr - j : cr, c = d ? cc : cc - j;
            var x = self.fits(w, r, c, d);
            if (x < 1) continue;
            var nr0 = r < r0 ? r : r0, nc0 = c < c0 ? c : c0;
            var er = r + d * (L - 1), ec = c + (1 - d) * (L - 1);
            var nr1 = er > r1 ? er : r1, nc1 = ec > c1 ? ec : c1;
            var pitch = Math.min(W / (nc1 - nc0 + 1), H / (nr1 - nr0 + 1));
            var s = pitch + 0.35 * (x - 1) + rand() * jitter;
            if (s > bestS) { bestS = s; best = [r, c, d]; }
          }
        }
        if (best) { put(wi, best[0], best[1], best[2]); pending.splice(p, 1); p--; moved = true; }
      }
    }
    var rows = r1 - r0 + 1, cols = c1 - c0 + 1;
    var pitch = Math.min(W / cols, H / rows, this.pitchMax);
    var placed = words.length - pending.length;
    var q = placed * 1000 + pitch * 20 + crosses * 1.2 + (tiles / (rows * cols)) * 6;
    var place = [];
    for (var i = 0; i < words.length; i++) place.push(pos[i] ? [pos[i][0] - r0, pos[i][1] - c0, pos[i][2]] : null);
    return { place: place, rows: rows, cols: cols, pitch: pitch, crosses: crosses, placed: placed, missing: pending.map(function (i) { return words[i]; }), q: q };
  };

  function sameish(a, b, need) {
    var diff = 0;
    for (var i = 0; i < a.place.length; i++) {
      var p = a.place[i], o = b.place[i];
      if (!p || !o || p[0] !== o[0] || p[1] !== o[1] || p[2] !== o[2]) diff++;
      if (diff >= need) return false;
    }
    return true;
  }

  Searcher.prototype.offer = function (res) {
    var need = Math.max(1, Math.floor(this.words.length / 4)), list = this.best;
    for (var i = 0; i < list.length; i++) {
      if (sameish(list[i], res, need)) { if (res.q > list[i].q) { list[i] = res; list.sort(function (a, b) { return b.q - a.q; }); } return; }
    }
    list.push(res); list.sort(function (a, b) { return b.q - a.q; });
    if (list.length > this.keep) list.length = this.keep;
  };

  Searcher.prototype.search = function (seed, ms, maxPasses) {
    var words = this.words, n = words.length, rand = rng(seed || 1), now = root.performance && root.performance.now ? function () { return root.performance.now(); } : Date.now;
    var t0 = now(), idx = []; for (var i = 0; i < n; i++) idx.push(i);
    var byLen = idx.slice().sort(function (a, b) { return words[b].length - words[a].length; });
    maxPasses = maxPasses || 60000;
    for (var t = 0; t < maxPasses; t++) {
      if (n < 2) { this.offer(this.pass(idx, rand, 0, 0)); break; }
      var order;
      if (t === 0) order = byLen.slice();
      else {
        order = byLen.slice();
        var spine = order.splice(Math.floor(rand() * Math.min(n, 4)), 1)[0];
        var noise = 1 + rand() * 4;
        order.sort(function (a, b) { return (words[b].length - words[a].length) + (rand() - 0.5) * noise; });
        order.unshift(spine);
      }
      var jitter = t === 0 ? 0 : 0.2 + rand() * 2.2;
      this.offer(this.pass(order, rand, jitter, rand() < 0.22 ? 1 : 0));
      this.passes++;
      if ((t & 7) === 7 && now() - t0 > ms) break;
    }
    return this.best;
  };

  /* Re-checks a saved layout (from a shared link): no clashes, no side-by-side letters, one connected piece.
     Returns it with its measurements, or null. */
  function validate(words, place) {
    if (!place || place.length !== words.length || !words.length) return null;
    var ch = new Uint16Array(N * N), fl = new Uint8Array(N * N), r1 = 0, c1 = 0, crosses = 0, B = 20, i, j, k;
    for (i = 0; i < words.length; i++) {             /* 1. lay every word; letters must agree, one word per direction per cell */
      var p = place[i];
      if (!p || p.length !== 3 || p[0] < 0 || p[1] < 0 || p[0] > 60 || p[1] > 60) return null;
      var r = p[0] + B, c = p[1] + B, d = p[2] ? 1 : 0, w = words[i];
      for (j = 0; j < w.length; j++) {
        k = (r + d * j) * N + (c + (1 - d) * j);
        if (ch[k] && ch[k] !== w.charCodeAt(j)) return null;
        if (fl[k] & (d ? 2 : 1)) return null;
        if (ch[k]) crosses++;
        ch[k] = w.charCodeAt(j); fl[k] |= d ? 2 : 1;
      }
      r1 = Math.max(r1, p[0] + d * (w.length - 1)); c1 = Math.max(c1, p[1] + (1 - d) * (w.length - 1));
    }
    for (i = 0; i < words.length; i++) {             /* 2. on the finished grid: clear ends, no side-by-side letters except at crossings */
      var q2 = place[i], rr0 = q2[0] + B, cc0 = q2[1] + B, dd = q2[2] ? 1 : 0, ww = words[i], dr = dd, dc = 1 - dd;
      if (ch[(rr0 - dr) * N + (cc0 - dc)] || ch[(rr0 + dr * ww.length) * N + (cc0 + dc * ww.length)]) return null;
      for (j = 0; j < ww.length; j++) {
        var rr = rr0 + dr * j, cc = cc0 + dc * j;
        if (fl[rr * N + cc] === 3) continue;
        if (ch[(rr + dc) * N + (cc + dr)] || ch[(rr - dc) * N + (cc - dr)]) return null;
      }
    }
    var start = -1, total = 0, seen = new Uint8Array(N * N), stack = [], got = 0;
    for (var q = 0; q < ch.length; q++) if (ch[q]) { total++; if (start < 0) start = q; }
    stack.push(start); seen[start] = 1;
    while (stack.length) {
      var at = stack.pop(); got++;
      [at - 1, at + 1, at - N, at + N].forEach(function (nb) { if (ch[nb] && !seen[nb]) { seen[nb] = 1; stack.push(nb); } });
    }
    if (got !== total) return null;
    var rows = r1 + 1, cols = c1 + 1;
    return { place: place, rows: rows, cols: cols, pitch: Math.min(GEO.areaW / cols, GEO.areaH / rows, GEO.pitchMax), crosses: crosses, placed: words.length, missing: [], q: 0 };
  }

  /* ---- design codes: the #xw link and the cart line's _Crossword design (base64url JSON). 2026-10-05: one reader for
     the page and the cart, which treats a code as untrusted (fixed lists for colours, length limits, the layout
     re-checked by validate()); anything that does not check out is null. ---- */
  var FRAME_NAMES = ['Black', 'Walnut', 'White'], BG_NAMES = ['White', 'Hazelnut', 'Jacobean', 'Black', 'Mahogany'];
  function b64(s) { return btoa(unescape(encodeURIComponent(s))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); }
  function unb64(s) { s = s.replace(/-/g, '+').replace(/_/g, '/'); while (s.length % 4) s += '='; return decodeURIComponent(escape(atob(s))); }
  function encodeDesign(o) { return b64(JSON.stringify({ v: o.v, f: o.f, b: o.b, t: o.t, s: o.s, n: o.n, l: o.l })); }
  function readDesign(code) {
    if (typeof code !== 'string' || code.length > 8000 || !/^[A-Za-z0-9_-]+$/.test(code)) return null;
    var d; try { d = JSON.parse(unb64(code)); } catch (e) { return null; }
    if (!d || typeof d !== 'object' || (d.v !== 1 && d.v !== 2)) return null;
    if (FRAME_NAMES.indexOf(d.f) < 0 || BG_NAMES.indexOf(d.b) < 0) return null;
    if ((d.t != null && typeof d.t !== 'string') || (d.s != null && typeof d.s !== 'string')) return null;
    var t = String(d.t || '').trim(), s = String(d.s || '').trim();
    if (t.length > 60 || s.length > 60) return null;
    if (!Array.isArray(d.n) || d.n.length < 2 || d.n.length > 20) return null;
    for (var i = 0; i < d.n.length; i++) if (typeof d.n[i] !== 'string' || !d.n[i].trim() || d.n[i].length > 40 || /[\n,;]/.test(d.n[i])) return null;
    var parsed = parseNames(d.n.join('\n'), 20, d.v === 1);
    if (parsed.list.length !== d.n.length) return null;
    var words = parsed.list.map(function (p) { return p.word; });
    if (!Array.isArray(d.l) || d.l.length !== words.length) return null;
    var place = [];
    for (i = 0; i < d.l.length; i++) {
      var p = d.l[i];
      if (!Array.isArray(p) || p.length !== 3 || p.some(function (v) { return typeof v !== 'number' || !isFinite(v) || v % 1; }) || (p[2] !== 0 && p[2] !== 1)) return null;
      place.push([p[0], p[1], p[2]]);
    }
    var lay = validate(words, place);
    if (!lay) return null;
    return { v: d.v, frame: d.f, bg: d.b, t: t, s: s, typed: parsed.list.map(function (q) { return q.typed; }), words: words, layout: lay, score: totalScore(words) };
  }
  /* what the frame shows for a design: no example title or subtitle, ever (2026-10-05) */
  function sceneOf(d) {
    return { frame: d.frame, bg: d.bg, title: d.t.toLocaleUpperCase('en-US'), sub: d.s.toLocaleUpperCase('en-US'), score: d.score, words: d.words, layout: d.layout, example: false };
  }
  /* cart lines are matched by their properties: keys change when the bulk discount re-allocates */
  function canon(props) { var o = props || {}; return JSON.stringify(Object.keys(o).sort().map(function (k) { return [k, String(o[k])]; })); }
  function lineQty(items, c) { var q = 0; (items || []).forEach(function (it) { if (canon(it.properties) === c) q += it.quantity || 0; }); return q; }
  /* after an edit's add: the old line goes; an unchanged design merged into the old line, which goes back to its quantity */
  function planEdit(items, oldC, newC, qty) {
    if (!oldC) return { op: 'none' };
    var old = null;
    (items || []).forEach(function (it) { if (!old && canon(it.properties) === oldC) old = it; });
    if (!old) return { op: 'none' };
    return { op: 'set', key: old.key, qty: oldC === newC ? qty : 0 };
  }
  /* cart/add.js: ok; refused (a 4xx with Shopify's error body: nothing was added); unknown (no answer, a 5xx or an
     unreadable body: the cart has to be read before anything is sent again) */
  function addOutcome(status, body) {
    if (status >= 200 && status < 300) return body && Array.isArray(body.items) && body.items.length ? 'ok' : 'unknown';
    if (status >= 400 && status < 500 && body && (body.status || body.description || body.message)) return 'refused';
    return 'unknown';
  }

  var ENGINE = { VALUES: VALUES, GEO: GEO, ICONS: ICONS, titleTokens: titleTokens, layoutLine: layoutLine, tileWord: tileWord, legacyClean: legacyClean, tileValue: tileValue, parseNames: parseNames, wordScore: wordScore, totalScore: totalScore, rng: rng, Searcher: Searcher, validate: validate,
                 encodeDesign: encodeDesign, readDesign: readDesign, sceneOf: sceneOf, canon: canon, lineQty: lineQty, planEdit: planEdit, addOutcome: addOutcome };
  if (typeof module !== 'undefined' && module.exports) { module.exports = ENGINE; return; }
  root.ASCXW = ENGINE;
  if (typeof document === 'undefined') return;

  /* ---------------- 2. Drawing ---------------- */
  var FRAMES = {
    Black:  { top: '#2c2c2e', left: '#262628', right: '#1c1c1e', bottom: '#161618', lip: '#0e0e0f', hl: 'rgba(255,255,255,.10)', grain: null },
    Walnut: { top: '#5b4030', left: '#533a2b', right: '#453125', bottom: '#3b2a20', lip: '#271b14', hl: 'rgba(255,230,200,.10)', grain: 'rgba(18,10,6,' },
    White:  { top: '#fbfbfa', left: '#f4f4f2', right: '#e6e6e3', bottom: '#dcdcd9', lip: '#cbcbc6', hl: 'rgba(255,255,255,.9)', grain: null }
  };
  /* Backgrounds: stain colours sampled from the product photos. Tiles: natural wood on white, white on the wood
     colours; engraving dark on white and hazelnut, light (natural wood) on the dark stains. */
  var BGS = {
    White:    { base: '#f2f1ed', wood: false, tile: 'wood',  ink: '#2d2119' },
    Hazelnut: { base: '#a8773f', dark: '#6e4520', light: '#d8a870', wood: true, tile: 'white', ink: '#2d2119', grain: 1.5 },
    Jacobean: { base: '#4b3a30', dark: '#2e221b', light: '#6d5646', wood: true, tile: 'white', ink: '#dcc6a0' },
    Black:    { base: '#1f1e20', dark: '#101012', light: '#3b393a', wood: true, tile: 'white', ink: '#dcc6a0' },
    Mahogany: { base: '#4e2b24', dark: '#301914', light: '#6f3f33', wood: true, tile: 'white', ink: '#dcc6a0' }
  };
  var TILE = {
    wood:  { face: '#dcc49c', edge: '#8a6440', ink: '#34261c', shadow: 'rgba(40,25,10,.38)' },
    white: { face: '#f5f3ee', edge: '#5e4c3f', ink: '#34261c', shadow: 'rgba(0,0,0,.55)' }
  };
  var F_TITLE = "'ASCXW Jost', 'Futura', 'Century Gothic', Arial, sans-serif";
  var F_TILE = "'ASCXW Oswald', 'Arial Narrow', Arial, sans-serif";
  var texCache = {};

  function hexRgb(h) { var n = parseInt(h.slice(1), 16); return [(n >> 16) & 255, (n >> 8) & 255, n & 255]; }
  function canvas(w, h) { var c = document.createElement('canvas'); c.width = w; c.height = h; return c; }
  function rrect(x, ctx, a, b, w, h, r) { x.beginPath(); x.moveTo(a + r, b); x.arcTo(a + w, b, a + w, b + h, r); x.arcTo(a + w, b + h, a, b + h, r); x.arcTo(a, b + h, a, b, r); x.arcTo(a, b, a + w, b, r); x.closePath(); }
  function noise(x, w, h, amount, seed) {
    var img = x.getImageData(0, 0, w, h), d = img.data, r = rng(seed);
    for (var i = 0; i < d.length; i += 4) { var n = (r() - 0.5) * amount; d[i] += n; d[i + 1] += n; d[i + 2] += n; }
    x.putImageData(img, 0, 0);
  }
  function streaks(x, w, h, count, dark, light, seed, alphaMax, widthMax) {
    var r = rng(seed);
    for (var i = 0; i < count; i++) {
      var y = r() * h, amp = 1 + r() * h * 0.012, f1 = (0.6 + r() * 2.4) * Math.PI * 2 / w, ph = r() * 6.3, amp2 = r() * 3, f2 = (3 + r() * 9) * Math.PI * 2 / w;
      var col = r() < 0.55 ? dark : light, a = 0.03 + r() * alphaMax;
      x.strokeStyle = 'rgba(' + col[0] + ',' + col[1] + ',' + col[2] + ',' + a.toFixed(3) + ')';
      x.lineWidth = 0.5 + r() * r() * widthMax;
      x.beginPath();
      for (var px = -10; px <= w + 10; px += 12) { var py = y + amp * Math.sin(px * f1 + ph) + amp2 * Math.sin(px * f2); if (px === -10) x.moveTo(px, py); else x.lineTo(px, py); }
      x.stroke();
    }
  }
  function bgTexture(name) {
    if (texCache['bg' + name]) return texCache['bg' + name];
    var b = BGS[name], S = 1024, c = canvas(S, S), x = c.getContext('2d');
    x.fillStyle = b.base; x.fillRect(0, 0, S, S);
    if (b.wood) {
      var dk = hexRgb(b.dark), lt = hexRgb(b.light);
      var gk = b.grain || 1;
      streaks(x, S, S, 26, dk, lt, 11 + name.length, 0.07 * gk, 60);
      streaks(x, S, S, Math.round(260 * gk), dk, lt, 97 + name.length * 7, 0.22 * gk, 3.2);
      noise(x, S, S, name === 'Black' ? 7 : 10, 5);
    } else {
      var g = x.createLinearGradient(0, 0, S, S); g.addColorStop(0, 'rgba(255,255,255,.35)'); g.addColorStop(1, 'rgba(0,0,0,.03)');
      x.fillStyle = g; x.fillRect(0, 0, S, S); noise(x, S, S, 4, 3);
    }
    return (texCache['bg' + name] = c);
  }
  function birchTexture() {
    if (texCache.birch) return texCache.birch;
    var S = 512, c = canvas(S, S), x = c.getContext('2d');
    x.fillStyle = TILE.wood.face; x.fillRect(0, 0, S, S);
    streaks(x, S, S, 14, [196, 160, 112], [238, 220, 186], 21, 0.10, 40);
    streaks(x, S, S, 220, [178, 140, 96], [240, 224, 194], 43, 0.20, 2.2);
    noise(x, S, S, 9, 8);
    return (texCache.birch = c);
  }
  function mdfTexture() {
    if (texCache.mdf) return texCache.mdf;
    var S = 256, c = canvas(S, S), x = c.getContext('2d');
    x.fillStyle = TILE.white.face; x.fillRect(0, 0, S, S); noise(x, S, S, 5, 13);
    return (texCache.mdf = c);
  }

  function capRatio(x, font) { x.font = '500 100px ' + font; var m = x.measureText('H'); return (m.actualBoundingBoxAscent || 70) / 100; }
  function canvasMeasure(x, font) {
    var cache = {};
    return function (ch, size) {
      if (!(ch in cache)) { x.font = '500 100px ' + font; cache[ch] = x.measureText(ch).width / 100; }
      return cache[ch] * size;
    };
  }

  /* Engraved text line: size chosen so the capital height matches the drawing, then shrunk if it is wider than the window. */
  function engraveLine(x, text, s, winX, top, cap, track, ink, maxW) {
    if (!text) return;
    var ratio = capRatio(x, F_TITLE);
    var L = layoutLine(titleTokens(text).tokens, canvasMeasure(x, F_TITLE), ratio, { cx: winX / s, top: top, cap: cap, track: track, maxW: maxW });
    x.font = '500 ' + (L.size * s).toFixed(2) + 'px ' + F_TITLE; x.textAlign = 'left'; x.fillStyle = ink;
    L.items.forEach(function (it) {
      if (it.icon) {
        var b = it.box * s, px = it.x * s + (it.adv * s - b) / 2, py = (L.base - L.capH / 2) * s - b / 2;
        x.save(); x.translate(px, py); x.scale(b / 256, b / 256); x.fill(iconPath(it.icon)); x.restore();
      } else x.fillText(it.ch, it.x * s, L.base * s);
    });
  }
  var pathCache = {};
  function iconPath(ic) { return pathCache[ic.k] || (pathCache[ic.k] = new Path2D(ic.d)); }

  function drawTile(x, px, py, t, s, letter, value, kind, seed) {
    var st = TILE[kind], r = Math.max(0.5, 0.55 * s);
    x.save();
    x.shadowColor = st.shadow; x.shadowBlur = 0.9 * s; x.shadowOffsetX = 0.35 * s; x.shadowOffsetY = 0.55 * s;
    x.fillStyle = st.edge; rrect(x, null, px, py, t, t, r); x.fill();
    x.restore();
    var e = Math.max(0.6, 0.3 * s);
    x.save();
    rrect(x, null, px + e * 0.6, py + e * 0.5, t - e * 1.4, t - e * 1.4, r * 0.8); x.clip();
    var tex = kind === 'wood' ? birchTexture() : mdfTexture(), rr = rng(seed), span = Math.min(tex.width, 12 * 8.5);
    var sx = rr() * (tex.width - span), sy = rr() * (tex.height - span);
    x.drawImage(tex, sx, sy, span, span, px, py, t, t);
    var g = x.createLinearGradient(px, py, px + t, py + t);
    g.addColorStop(0, 'rgba(255,255,255,.16)'); g.addColorStop(0.55, 'rgba(255,255,255,0)'); g.addColorStop(1, 'rgba(0,0,0,.07)');
    x.fillStyle = g; x.fillRect(px, py, t, t);
    x.restore();
    /* letter + value: engraved dark brown, a hair of light below for depth */
    var lsz = t * 0.56, vsz = t * 0.22;
    x.textAlign = 'center';
    x.font = '500 ' + lsz.toFixed(2) + 'px ' + F_TILE;
    var cap = lsz * capRatio(x, F_TILE);
    x.font = '500 ' + lsz.toFixed(2) + 'px ' + F_TILE;
    var lx = px + t * 0.46, ly = py + t * 0.49 + cap / 2;
    x.fillStyle = 'rgba(255,255,255,.35)'; x.fillText(letter, lx + 0.06 * s, ly + 0.08 * s);
    x.fillStyle = st.ink; x.fillText(letter, lx, ly);
    x.font = '500 ' + vsz.toFixed(2) + 'px ' + F_TILE; x.textAlign = 'right';
    x.fillText(String(value), px + t * 0.9, py + t * 0.9);
    x.textAlign = 'left';
  }

  function framePath(x, pts) { x.beginPath(); x.moveTo(pts[0], pts[1]); for (var i = 2; i < pts.length; i += 2) x.lineTo(pts[i], pts[i + 1]); x.closePath(); }

  function drawMoulding(x, ox, oy, s, name) {
    var f = FRAMES[name], O = GEO.outer * s, R = GEO.rail * s;
    var parts = [
      { c: f.top, p: [0, 0, O, 0, O - R, R, R, R], horiz: true },
      { c: f.right, p: [O, 0, O, O, O - R, O - R, O - R, R], horiz: false },
      { c: f.bottom, p: [O, O, 0, O, R, O - R, O - R, O - R], horiz: true },
      { c: f.left, p: [0, O, 0, 0, R, R, R, O - R], horiz: false }
    ];
    x.save(); x.translate(ox, oy);
    parts.forEach(function (pt, i) {
      framePath(x, pt.p); x.fillStyle = pt.c; x.fill();
      if (f.grain) {
        x.save(); framePath(x, pt.p); x.clip();
        var r = rng(31 + i * 17);
        for (var k = 0; k < 70; k++) {
          var a = (0.04 + r() * 0.22).toFixed(3), off = r() * R, lw = (0.2 + r() * r() * 1.4) * s * 0.3;
          x.strokeStyle = f.grain + a + ')'; x.lineWidth = lw; x.beginPath();
          if (pt.horiz) { var yy = (i === 0 ? 0 : O - R) + off; x.moveTo(0, yy); x.bezierCurveTo(O * 0.3, yy + (r() - 0.5) * 2 * s, O * 0.7, yy + (r() - 0.5) * 2 * s, O, yy + (r() - 0.5) * s); }
          else { var xx = (i === 3 ? 0 : O - R) + off; x.moveTo(xx, 0); x.bezierCurveTo(xx + (r() - 0.5) * 2 * s, O * 0.3, xx + (r() - 0.5) * 2 * s, O * 0.7, xx + (r() - 0.5) * s, O); }
          x.stroke();
        }
        for (var q = 0; q < 3; q++) {          /* the few fine black lines of the walnut finish */
          x.strokeStyle = 'rgba(8,5,3,.55)'; x.lineWidth = 0.25 * s; x.beginPath();
          var st0 = r() * O * 0.8, len = (6 + r() * 14) * s, o2 = (0.25 + r() * 0.5) * R;
          if (pt.horiz) { var y2 = (i === 0 ? 0 : O - R) + o2; x.moveTo(st0, y2); x.lineTo(st0 + len, y2 + (r() - 0.5) * 0.4 * s); }
          else { var x2 = (i === 3 ? 0 : O - R) + o2; x.moveTo(x2, st0); x.lineTo(x2 + (r() - 0.5) * 0.4 * s, st0 + len); }
          x.stroke();
        }
        x.restore();
      }
    });
    /* mitre seams, outer highlight, inner lip */
    x.strokeStyle = 'rgba(0,0,0,.18)'; x.lineWidth = Math.max(0.5, 0.15 * s);
    x.beginPath(); x.moveTo(0, 0); x.lineTo(R, R); x.moveTo(O, 0); x.lineTo(O - R, R); x.moveTo(O, O); x.lineTo(O - R, O - R); x.moveTo(0, O); x.lineTo(R, O - R); x.stroke();
    x.strokeStyle = f.hl; x.lineWidth = Math.max(0.6, 0.35 * s); x.strokeRect(0.2 * s, 0.2 * s, O - 0.4 * s, O - 0.4 * s);
    var lip = 1.3 * s; x.fillStyle = f.lip;
    x.fillRect(R - lip, R - lip, O - 2 * R + 2 * lip, lip); x.fillRect(R - lip, O - R, O - 2 * R + 2 * lip, lip);
    x.fillRect(R - lip, R, lip, O - 2 * R); x.fillRect(O - R, R, lip, O - 2 * R);
    x.restore();
  }

  /* Draws the whole frame with its top-left corner at (ox, oy); s = pixels per millimetre. */
  function drawFrame(x, ox, oy, s, st) {
    var O = GEO.outer * s, R = GEO.rail * s, M = GEO.mat * s, Wn = GEO.win * s, wx = ox + R + M, wy = oy + R + M;
    var bg = BGS[st.bg] || BGS.White, tileKind = bg.tile;
    /* mat */
    x.fillStyle = '#f6f6f3'; x.fillRect(ox + R, oy + R, O - 2 * R, O - 2 * R);
    var mg = x.createLinearGradient(0, oy + R, 0, oy + O - R); mg.addColorStop(0, 'rgba(255,255,255,.5)'); mg.addColorStop(1, 'rgba(0,0,0,.025)');
    x.fillStyle = mg; x.fillRect(ox + R, oy + R, O - 2 * R, O - 2 * R);
    var sh = x.createLinearGradient(0, oy + R, 0, oy + R + 3 * s); sh.addColorStop(0, 'rgba(0,0,0,.16)'); sh.addColorStop(1, 'rgba(0,0,0,0)');
    x.fillStyle = sh; x.fillRect(ox + R, oy + R, O - 2 * R, 3 * s);
    var sl = x.createLinearGradient(ox + R, 0, ox + R + 2.5 * s, 0); sl.addColorStop(0, 'rgba(0,0,0,.10)'); sl.addColorStop(1, 'rgba(0,0,0,0)');
    x.fillStyle = sl; x.fillRect(ox + R, oy + R, 2.5 * s, O - 2 * R);
    /* background board */
    x.save(); x.beginPath(); x.rect(wx, wy, Wn, Wn); x.clip();
    x.drawImage(bgTexture(st.bg), wx, wy, Wn, Wn);
    /* title, subtitle, score */
    var ink = bg.ink, cx = wx + Wn / 2;
    /* before any name is typed the example crossword fills the board and an empty title or subtitle shows the example
       the field is typing (Murat, 2026-09-29: full strength). 2026-10-05: once the customer has names, an empty line
       stays empty, so the editor, the final review and the cart all show exactly what is engraved. */
    engraveLine(x, st.title || (st.example ? st.ghostTitle : ''), s, cx, wy / s + GEO.titleTop, GEO.titleCap, 0.045, ink, GEO.win - 16);
    engraveLine(x, st.sub || (st.example ? st.ghostSub : ''), s, cx, wy / s + GEO.titleTop + GEO.titleCap + GEO.gap, GEO.subCap, 0.07, ink, GEO.win - 16);
    engraveLine(x, 'SCORE ' + st.score, s, cx, wy / s + GEO.scoreTop, GEO.scoreCap, 0.1, ink, GEO.win - 16);
    /* tiles */
    var lay = st.layout;
    if (lay && lay.place) {
      var p = lay.pitch, t = p * (1 - GEO.gapRatio);
      var gw = lay.cols * p - (p - t), gh = lay.rows * p - (p - t);
      var gx = wx / s + GEO.padX + (GEO.areaW - gw) / 2, gy = wy / s + GEO.bandTop + GEO.padY + (GEO.areaH - gh) / 2;
      tileCells(st.words, lay.place).forEach(function (cl) { drawTile(x, (gx + cl[1] * p) * s, (gy + cl[0] * p) * s, t * s, s, cl[2], tileValue(cl[2]), tileKind, cl[0] * 131 + cl[1] * 7 + 3); });
    }
    /* depth: the mat edge shades the recessed board, strongest along the top */
    var d1 = x.createLinearGradient(0, wy, 0, wy + 6 * s); d1.addColorStop(0, 'rgba(0,0,0,.30)'); d1.addColorStop(1, 'rgba(0,0,0,0)');
    x.fillStyle = d1; x.fillRect(wx, wy, Wn, 6 * s);
    var d2 = x.createLinearGradient(wx, 0, wx + 4.5 * s, 0); d2.addColorStop(0, 'rgba(0,0,0,.20)'); d2.addColorStop(1, 'rgba(0,0,0,0)');
    x.fillStyle = d2; x.fillRect(wx, wy, 4.5 * s, Wn);
    var d3 = x.createLinearGradient(wx + Wn, 0, wx + Wn - 2 * s, 0); d3.addColorStop(0, 'rgba(0,0,0,.08)'); d3.addColorStop(1, 'rgba(0,0,0,0)');
    x.fillStyle = d3; x.fillRect(wx + Wn - 2 * s, wy, 2 * s, Wn);
    x.restore();
    /* mat bevel */
    x.strokeStyle = '#e6dfd0'; x.lineWidth = Math.max(1, 0.7 * s); x.strokeRect(wx - 0.35 * s, wy - 0.35 * s, Wn + 0.7 * s, Wn + 0.7 * s);
    /* acrylic front: a soft diagonal sheen */
    var gl = x.createLinearGradient(ox + R, oy + R, ox + O - R, oy + O - R);
    gl.addColorStop(0, 'rgba(255,255,255,0)'); gl.addColorStop(0.22, 'rgba(255,255,255,.035)'); gl.addColorStop(0.3, 'rgba(255,255,255,.06)'); gl.addColorStop(0.38, 'rgba(255,255,255,.035)'); gl.addColorStop(0.5, 'rgba(255,255,255,0)');
    x.save(); x.beginPath(); x.rect(wx, wy, Wn, Wn); x.clip(); x.fillStyle = gl; x.fillRect(wx, wy, Wn, Wn); x.restore();
    drawMoulding(x, ox, oy, s, FRAMES[st.frame] ? st.frame : 'Black');
  }

  /* The on-screen scene: the frame on a light wall with a soft shadow. Canvas = 272 mm square. */
  var SCENE = 272;
  function drawScene(cv, st) {
    var x = cv.getContext('2d'), S = cv.width, s = S / SCENE, ox = (SCENE - GEO.outer) / 2 * s, oy = ox - 2 * s;
    var g = x.createLinearGradient(0, 0, 0, S); g.addColorStop(0, '#f1f0ec'); g.addColorStop(1, '#e5e2dc');
    x.fillStyle = g; x.fillRect(0, 0, S, S);
    x.save(); x.shadowColor = 'rgba(40,28,16,.30)'; x.shadowBlur = 7 * s; x.shadowOffsetY = 3.5 * s; x.shadowOffsetX = 1 * s;
    x.fillStyle = '#222'; x.fillRect(ox, oy, GEO.outer * s, GEO.outer * s); x.restore();
    drawFrame(x, ox, oy, s, st);
  }
  /* the frame's two self-hosted fonts; never waits longer than ms (a failed font draws with the fallback stack) */
  function loadFonts(list, ms, onAll) {
    if (!root.FontFace || !document.fonts || !list || !list.length) return Promise.resolve();
    var all = Promise.all(list.map(function (f) {
      var ff = new FontFace(f.family, 'url(' + f.url + ') format("woff2")', { weight: '500', style: 'normal', display: 'swap' });
      return ff.load().then(function (l) { document.fonts.add(l); }).catch(function () {});
    }));
    if (onAll) all.then(onAll);
    return Promise.race([all, new Promise(function (res) { setTimeout(res, ms || 3000); })]);
  }
  /* the cart's saved-design thumbnails draw with this (assets/asc-xw-cart-preview.js), before the page guard below */
  ENGINE.drawScene = drawScene;
  ENGINE.loadFonts = loadFonts;

  /* ---------------- 3. PDF (one page, the rendered sheet as a JPEG) ---------------- */
  function pdfBytes(jpeg, pxW, pxH, ptW, ptH, link, title) {
    var enc = new TextEncoder(), parts = [], len = 0, offs = [];
    function add(x) { var b = typeof x === 'string' ? enc.encode(x) : x; parts.push(b); len += b.length; }
    function obj(n, body) { offs[n] = len; add(n + ' 0 obj\n'); body(); add('\nendobj\n'); }
    function esc(t) { return String(t).replace(/[\\()]/g, '\\$&').replace(/[^\x20-\x7e]/g, ''); }
    var content = 'q ' + ptW + ' 0 0 ' + ptH + ' 0 0 cm /Im0 Do Q';
    add('%PDF-1.4\n%\xE2\xE3\xCF\xD3\n');
    obj(1, function () { add('<< /Type /Catalog /Pages 2 0 R >>'); });
    obj(2, function () { add('<< /Type /Pages /Kids [3 0 R] /Count 1 >>'); });
    obj(3, function () { add('<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ' + ptW + ' ' + ptH + '] /Resources << /XObject << /Im0 4 0 R >> >> /Contents 5 0 R' + (link ? ' /Annots [7 0 R]' : '') + ' >>'); });
    obj(4, function () { add('<< /Type /XObject /Subtype /Image /Width ' + pxW + ' /Height ' + pxH + ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' + jpeg.length + ' >>\nstream\n'); add(jpeg); add('\nendstream'); });
    obj(5, function () { add('<< /Length ' + content.length + ' >>\nstream\n' + content + '\nendstream'); });
    obj(6, function () { add('<< /Title (' + esc(title) + ') /Author (ASC Gifts) /Producer (ascgifts.com) >>'); });
    if (link) obj(7, function () { add('<< /Type /Annot /Subtype /Link /Rect [' + link.rect.join(' ') + '] /Border [0 0 0] /A << /S /URI /URI (' + esc(link.url) + ') >> >>'); });
    var n = link ? 8 : 7, xref = len;
    add('xref\n0 ' + n + '\n0000000000 65535 f \n');
    for (var i = 1; i < n; i++) add(String(offs[i]).padStart(10, '0') + ' 00000 n \n');
    add('trailer\n<< /Size ' + n + ' /Root 1 0 R /Info 6 0 R >>\nstartxref\n' + xref + '\n%%EOF');
    var out = new Uint8Array(len), o = 0;
    parts.forEach(function (b) { out.set(b, o); o += b.length; });
    return out;
  }

  /* ---------------- 4. Page ---------------- */
  var el = document.querySelector('[data-xw]');
  if (!el) return;
  var CFG = JSON.parse(el.querySelector('[data-xw-config]').textContent);
  /* ?p=<handle> from a crossword product page: order as that product (same frame and price, its own name in the cart) */
  (function () { var p = new URLSearchParams(location.search).get('p'); if (p && CFG.alts && CFG.alts[p]) CFG.product = CFG.alts[p]; })();
  var form = el.querySelector('[data-xw-form]'), cv = el.querySelector('[data-xw-canvas]');
  var namesEl = form.querySelector('[data-xw-names]'), titleEl = form.querySelector('[data-xw-title]'), subEl = form.querySelector('[data-xw-sub]');
  var countEl = el.querySelector('[data-xw-count]'), statusEl = el.querySelector('[data-xw-status]');
  var priceEl = el.querySelector('[data-xw-price]'), tierEl = el.querySelector('[data-xw-tier]'), posEl = el.querySelector('[data-xw-pos]');
  var nextBtn = el.querySelector('[data-xw-next]'), prevBtn = el.querySelector('[data-xw-prev]'), cartBtn = el.querySelector('[data-xw-cart]'), pdfBtn = el.querySelector('[data-xw-pdf]');
  var chipEl = el.querySelector('[data-xw-chip]'), alertEl = el.querySelector('[data-xw-alert]'), noteEl = el.querySelector('[data-xw-note]');
  var frameNameEl = el.querySelector('[data-xw-frame-name]'), bgNameEl = el.querySelector('[data-xw-bg-name]'), tabsEl = el.querySelector('[data-xw-tabs]'), stageEl = el.querySelector('[data-xw-stage]');
  var ICON_OK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>', ICON_WARN = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 8v5m0 3.5v.01M10.3 3.9L2.6 17.5A2 2 0 0 0 4.3 20.5h15.4a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z"/></svg>';
  var symToggle = el.querySelector('[data-xw-symtoggle]'), symGrid = el.querySelector('[data-xw-symgrid]');
  var wsEl = el.querySelector('[data-xw-ws]'), orderEl = el.querySelector('[data-xw-order]'), svgBtn = el.querySelector('[data-xw-svg]');
  var acceptedEl = el.querySelector('[data-xw-accepted]'), tiersEl = el.querySelector('[data-xw-tiers]'), symTargetEl = el.querySelector('[data-xw-symtarget]');
  /* 2026-10-05 (Murat): "Edit design" in the cart opens this page with ?edit=<cart line key>&q=<quantity>; the final
     review then replaces that line instead of adding a second frame */
  var editQ = new URLSearchParams(location.search), editKey = editQ.get('edit') || '', editQty = Math.max(1, Math.min(99, parseInt(editQ.get('q'), 10) || 1));
  /* 2026-10-05 (UX review): the main button never adds to the cart by itself. Its job follows the design: Add names /
     Add another name (to the names field), Fix names (to the problem), Review your frame (opens the final review,
     where the one real cart request is made). */
  var CTA = { names: 'Add names', more: 'Add another name', fix: 'Fix names', review: editKey ? 'Review changes' : 'Review your frame' }, ctaMode = 'names';
  var busy = false;    /* one cart request at a time (button, Enter, a second tap, a refine callback) */
  function track(n, p, o) { try { if (root.asc && root.asc.track) root.asc.track(n, p, o); } catch (e) {} }
  var MAX = 20, state = { frame: 'Black', bg: 'White', title: '', sub: '', words: [], typed: [], score: 0, layout: null, legacy: false }, search = null, pick = 0, seed = 7, key = '', drawT = 0, drawT2 = 0, fontsReady = false;

  function radio(name) { var r = form.querySelector('input[name="' + name + '"]:checked'); return r ? r.value : ''; }
  function tier(n) { for (var i = 0; i < CFG.tiers.length; i++) if (n <= CFG.tiers[i].max) return CFG.tiers[i]; return CFG.tiers[CFG.tiers.length - 1]; }
  function rate() { var c = root.Shopify && root.Shopify.currency; return c && c.rate ? parseFloat(c.rate) || 1 : 1; }
  function cur() { var c = root.Shopify && root.Shopify.currency; return (c && c.active) || CFG.currency || 'USD'; }
  function money(cents) {
    try { var v = cents / 100; return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur(), minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: 2 }).format(v); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function addCents(t) { return Math.round(t.add * 100 * rate()); }

  function sizeCanvas() {
    var w = Math.round(cv.getBoundingClientRect().width || 560), dpr = Math.min(root.devicePixelRatio || 1, 2.5), px = Math.round(w * dpr);
    if (cv.width !== px) { cv.width = px; cv.height = px; }
  }
  function draw() {
    cancelAnimationFrame(drawT); clearTimeout(drawT2);
    var go = function () { sizeCanvas(); drawScene(cv, state); };
    if (document.hidden) drawT2 = setTimeout(go, 0); else drawT = requestAnimationFrame(go);
  }
  /* test hook: the same scene at any size, as a data URL (QA scripts save it to disk) */
  ENGINE.snapshot = function (px, type) { var c = canvas(px, px); drawScene(c, state); return c.toDataURL(type || 'image/jpeg', 0.9); };

  var titleDropped = [];
  function readForm() {
    state.frame = radio('xw-frame') || 'Black';
    state.bg = radio('xw-bg') || 'White';
    state.title = titleEl.value.trim().toLocaleUpperCase('en-US');
    state.sub = subEl.value.trim().toLocaleUpperCase('en-US');
    titleDropped = titleTokens(state.title).dropped.concat(titleTokens(state.sub).dropped);
    if (frameNameEl) frameNameEl.textContent = state.frame;
    if (bgNameEl) bgNameEl.textContent = state.bg;
    /* the frame pill slides to the choice; the background boards take the chosen frame colour */
    var seg = el.querySelector('[data-xw-seg]'), boards = el.querySelector('[data-xw-boards]');
    if (seg) seg.style.setProperty('--i', String(['Black', 'Walnut', 'White'].indexOf(state.frame)));
    if (boards) {
      var fc = FRAME_TONES[state.frame] || FRAME_TONES.Black;
      boards.style.setProperty('--fc', fc[0]); boards.style.setProperty('--fm', fc[1]);
    }
    if (state.frame !== swFrame) paintSwatches();
  }
  /* 2026-09-29: the swatches are painted on small canvases. Browsers that force a dark look on pages (Samsung
     Internet's dark mode, Chrome's auto dark theme) repaint CSS colours and dim images, which turned the Black frame
     chip white and the White board grey on Murat's phone; a canvas is left as drawn, like the preview itself. */
  var FRAME_TONES = { Black: ['#232325', '#f6f6f3'], Walnut: ['#5a3f2f', '#f6f6f3'], White: ['#dcd8d0', '#fbfbf9'] };
  var CORNER_TONES = { black: ['#232325', '#f7f5f0'], walnut: ['#5a3f2f', '#f7f5f0'], white: ['#fdfdfb', '#e4e0d8'] };
  var BOARD_BASE = { White: '#f2f1ed', Hazelnut: '#a8773f', Jacobean: '#4b3a30', Black: '#1f1e20', Mahogany: '#4e2b24' };
  var boardSrc = {}, swFrame = null;
  function swatchCanvas(host) {
    var c = host.querySelector('canvas.at-xw__swc');
    if (!c) { c = document.createElement('canvas'); c.className = 'at-xw__swc'; c.setAttribute('aria-hidden', 'true'); host.appendChild(c); }
    var r = host.getBoundingClientRect(), d = Math.min(3, root.devicePixelRatio || 1);
    var w = Math.max(1, Math.round((r.width || 20) * d)), h = Math.max(1, Math.round((r.height || 20) * d));
    if (c.width !== w || c.height !== h) { c.width = w; c.height = h; }
    return { x: c.getContext('2d'), w: w, h: h, d: d };
  }
  function paintSwatches() {
    swFrame = state.frame;
    try {
      Array.prototype.forEach.call(el.querySelectorAll('.at-xw__corner'), function (sp) {
        var t = CORNER_TONES[(sp.className.match(/at-xw__corner--([a-z]+)/) || [])[1]]; if (!t) return;
        var S = swatchCanvas(sp), b = 4.5 * S.d;
        S.x.fillStyle = t[0]; S.x.fillRect(0, 0, S.w, S.h);
        S.x.fillStyle = t[1]; S.x.fillRect(b, b, S.w - 2 * b, S.h - 2 * b);
        /* a hairline of light at the edge: lost on the white pill, it outlines the black frame on a darkened one */
        S.x.lineWidth = S.d; S.x.strokeStyle = 'rgba(255,255,255,.45)'; S.x.strokeRect(S.d / 2, S.d / 2, S.w - S.d, S.h - S.d);
      });
      var fc = FRAME_TONES[state.frame] || FRAME_TONES.Black;
      Array.prototype.forEach.call(el.querySelectorAll('[data-board]'), function (sp) {
        var name = sp.getAttribute('data-board'), S = swatchCanvas(sp), src = boardSrc[name], b = 3 * S.d;
        S.x.fillStyle = BOARD_BASE[name] || '#ccc'; S.x.fillRect(0, 0, S.w, S.h);
        if (src) S.x.drawImage(src, 0, 0, S.w, S.h);
        S.x.lineWidth = b; S.x.strokeStyle = fc[1]; S.x.strokeRect(b * 1.5, b * 1.5, S.w - 3 * b, S.h - 3 * b);
        S.x.strokeStyle = fc[0]; S.x.strokeRect(b / 2, b / 2, S.w - b, S.h - b);
      });
    } catch (e) {}
  }
  /* each background board shows a crop of the texture the preview uses, so the swatch matches the frame */
  function boardTextures() {
    Array.prototype.forEach.call(el.querySelectorAll('[data-board]'), function (b) {
      try {
        var src = bgTexture(b.getAttribute('data-board')), c = canvas(120, 120), cx = c.getContext('2d'), crop = src.width * 0.34;
        cx.drawImage(src, (src.width - crop) / 2, (src.height - crop) / 2, crop, crop, 0, 0, 120, 120);
        boardSrc[b.getAttribute('data-board')] = c;
      } catch (e) {}
    });
    paintSwatches();
  }
  /* the title as it will be engraved (symbols kept as their characters, unusable characters out), original case */
  function cleanTitle(v) { return titleTokens(String(v || '').trim()).tokens.map(function (t) { return t.icon ? t.icon.c : t.ch; }).join('').replace(/\s+/g, ' ').trim(); }
  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* until the customer types a name the preview shows a faint example crossword */
  var EXAMPLE = parseNames(String(namesEl.getAttribute('data-example') || 'Noah, Harper, Ava, Benjamin, Jackson, Sophia, Mason, Ethan, Emily, Olivia'), MAX).list.map(function (p) { return p.word; });
  function relayout(fresh) {
    var parsed = parseNames(namesEl.value, MAX, state.legacy), words = parsed.list.map(function (p) { return p.word; });
    state.typed = parsed.list.map(function (p) { return p.typed; });
    state.example = !words.length && !namesEl.value.trim();
    if (state.example) words = EXAMPLE.slice();
    var k = (state.example ? 'ex:' : '') + words.join('|');
    if (k !== key || fresh) {
      key = k; state.words = words; state.score = totalScore(words); pick = 0; locked = false;
      if (words.length) { search = new Searcher(words); search.search(seed, 250, 2500); state.layout = search.best[0] || null; refine(); }
      else { search = null; state.layout = null; }
    }
    report(parsed);
  }

  /* After a pause the search keeps going in short slices; a better layout replaces the shown one only while the
     customer is still on the first suggestion and did not open a saved design. */
  var refineT = 0, locked = false;
  /* The layouts the arrows step through: only the ones where every name fits (Murat, 2026-09-28). When no layout
     fits them all, only the best one is offered, with the warning. */
  function choices() {
    if (!search) return [];
    var full = search.best.filter(function (b) { return !b.missing.length; });
    return full.length ? full : search.best.slice(0, 1);
  }
  function refine() {
    clearTimeout(refineT);
    var myKey = key, left = 8;
    (function tick() {
      refineT = setTimeout(function () {
        if (!search || key !== myKey || left-- <= 0) return;
        var shown = state.layout;
        search.search(seed + 1000 + left * 131, 150, 2500);
        var list = choices(), idx = list.indexOf(shown);
        if (pick === 0 && !locked && list[0] !== shown && (!shown || shown.missing.length || list[0].q > shown.q + 0.5)) { state.layout = list[0]; pick = 0; draw(); saveHash(); }
        else if (idx >= 0) pick = idx;
        else if (shown && !shown.missing.length) { pick = Math.min(pick, search.best.length); search.best.splice(pick, 0, shown); }
        else { pick = 0; state.layout = list[0]; draw(); }
        report(null);
        tick();
      }, 140);
    })();
  }

  var lastParsed = null;
  function report(parsed) {
    if (parsed) lastParsed = parsed; else parsed = lastParsed;
    var n = state.example ? 0 : state.words.length, t = tier(Math.max(n, 1)), lay = state.layout;
    tierEl.textContent = t.label;
    priceEl.textContent = money(CFG.product.price + addCents(t));
    /* the status sits on the preview: green when every name is on the board, orange when one is not */
    var missing = lay && n >= 2 ? lay.missing : [], nm = parsed ? parsed.notes : {};
    var typedOf = {}; (parsed ? parsed.list : []).forEach(function (p) { typedOf[p.word] = p.typed; });
    var missTyped = missing.map(function (w) { return typedOf[w] || w; });
    var over = !state.example && nm.over ? nm.over.length : 0;
    countEl.textContent = (n + over) + ' / ' + MAX;
    /* 2026-10-08: names typed with spaces only ("Mike Sarah Emma Jake") become one tile word; three words or more in one
       entry is almost always several names, so the customer is told how to keep them apart */
    var runOn = state.example ? [] : (nm.merged || []).filter(function (m) { return (m.typed.match(/ /g) || []).length >= 2; });
    var chip = '', chipState = 'ok';
    if (over) {
      /* 2026-10-05: more than 20 names is never trimmed quietly; the list has to get shorter before the review */
      chipState = 'warn'; chip = 'Too many names';
      alertEl.innerHTML = '<b>A frame holds up to 20 names.</b> You have typed ' + (MAX + over) + '. Please remove ' + over + (over === 1 ? ' name' : ' names') + ' to continue.';
    } else if (missing.length) {
      chipState = 'warn'; chip = missing.length === 1 ? '1 name doesn’t fit' : missing.length + ' names don’t fit';
      /* say what is known: a name with no letter in common with the others cannot cross them in any layout; otherwise
         only that the layouts tried so far could not place it */
      var lonely = missing.filter(function (w) { return !state.words.some(function (o, i) { return o !== w && Array.from(w).some(function (c) { return o.indexOf(c) >= 0; }); }); });
      var who = missing.length === 1 ? esc(missTyped[0]) : esc(missTyped.join(', '));
      alertEl.innerHTML = '<b>' + who + (missing.length === 1 ? ' doesn’t fit yet.' : ' don’t fit yet.') + '</b> ' +
        (lonely.length === missing.length
          ? (missing.length === 1 ? 'It shares no letter with the other names, so it has nowhere to cross them.' : 'They share no letter with the other names, so they have nowhere to cross them.') +
            ' Check the spelling, add a name that shares letters with both (your family name often does), or use a nickname.'
          : 'We couldn’t place ' + (missing.length === 1 ? 'it' : 'them') + ' in the layouts tried so far. Check the spelling, try the arrows on the preview, add a name that links them (like your family name), or use a nickname.') +
        (missing.some(function (w) { return /[^A-Z]/.test(w); }) ? ' An accented letter crosses only the same accented letter (É with É, not E).' : '');
    } else if (n === 1 && runOn.length) {
      chipState = 'warn'; chip = 'Separate the names';
      alertEl.innerHTML = '<b>Put a comma or a new line between names.</b> Right now “' + esc(runOn[0].typed) + '” is read as one name.';
      track('xw_runon_names', {}, { once: true });
    } else if (n === 1) {
      chipState = 'warn'; chip = 'Add a second name';
      alertEl.innerHTML = '<b>A crossword needs two names or more.</b> Add one that shares a letter with this one.';
    } else if (state.example) {
      chipState = 'info'; chip = 'Example · add your names';
    } else if (n >= 2 && lay) {
      chip = (n === 2 ? 'Both names fit' : 'All ' + n + ' names fit');
    }
    alertEl.hidden = chipState !== 'warn';
    if (chip !== chipEl.getAttribute('data-text') || chipState !== chipEl.getAttribute('data-state')) {
      chipEl.setAttribute('data-text', chip); chipEl.setAttribute('data-state', chipState);
      chipEl.innerHTML = (chipState === 'ok' ? ICON_OK : chipState === 'warn' ? ICON_WARN : '') + '<span>' + esc(chip) + '</span>';
      chipEl.hidden = !chip;
      chipEl.style.animation = 'none'; void chipEl.offsetWidth; chipEl.style.animation = '';
    }
    chipEl.tabIndex = chipState === 'warn' ? 0 : -1;
    /* quiet, informational: how the typed names were turned into tiles */
    /* hint with fixed examples (Murat: Emily → EMILY, José → JOSÉ), shown when a typed name was changed or has an accent */
    var hintEl = el.querySelector('[data-xw-hint]'), mergeEx = el.querySelector('[data-xw-hint-merge]');
    var changed = (nm.folded && nm.folded.length) || (nm.removed && nm.removed.length) || (nm.merged && nm.merged.length) || (nm.accented && nm.accented.length);
    if (hintEl) hintEl.hidden = !changed;
    if (mergeEx) mergeEx.hidden = !(nm.merged && nm.merged.length);
    var notes = [];
    if (nm.dropped && nm.dropped.length) notes.push(nm.dropped.join(', ') + (nm.dropped.length === 1 ? ' has' : ' have') + ' no Latin letters, so it cannot go on the tiles. Please type it in Latin letters.');
    if (nm.dup && nm.dup.length) notes.push(nm.dup.join(', ') + ' appears twice, so it is used once.');
    if (nm.short && nm.short.length) notes.push('Names need at least two letters (' + nm.short.join(', ') + ').');
    if (n >= 2 && runOn.length) notes.push(runOn.map(function (m) { return '“' + m.typed + '”'; }).join(', ') + (runOn.length === 1 ? ' became one word.' : ' became one word each.') + ' Put a comma between names to keep them apart.');
    noteEl.textContent = notes.join(' ');
    noteEl.hidden = !notes.length;
    /* the names exactly as the tiles will spell them */
    if (acceptedEl) {
      acceptedEl.textContent = n ? 'On the tiles: ' + state.words.join(' · ') : '';
      acceptedEl.hidden = !n;
    }
    var tnote = el.querySelector('[data-xw-tnote]');
    if (tnote) {
      tnote.textContent = titleDropped.length ? titleDropped.join(' ') + ' can’t be engraved, so ' + (titleDropped.length === 1 ? 'it is' : 'they are') + ' left out. Hearts, stars, paws, homes, trees and flowers work.' : '';
      tnote.hidden = !titleDropped.length;
    }
    var total = choices().length;
    posEl.textContent = total > 1 ? (pick + 1) + ' / ' + total : '';
    var ok = n >= 2 && lay && !lay.missing.length && !over;
    ctaMode = ok ? 'review' : n === 0 ? 'names' : n === 1 ? 'more' : 'fix';
    /* while a cart request is out, nothing here may rewrite the button or the status line */
    if (!busy) { statusEl.textContent = ''; cartBtn.disabled = false; cartBtn.textContent = CTA[ctaMode]; cartBtn.setAttribute('data-mode', ctaMode); }
    /* the PDF appears once there is a design of the customer's own to download */
    pdfBtn.hidden = !(n >= 1 && lay);
    if (svgBtn) svgBtn.disabled = !(n >= 2 && lay && !lay.missing.length);
    nextBtn.disabled = total < 2; prevBtn.disabled = nextBtn.disabled;
    cv.setAttribute('aria-label', 'Preview: ' + state.frame.toLowerCase() + ' frame, ' + state.bg.toLowerCase() + ' background' + (state.title ? ', title ' + state.title : '') + (state.sub ? ', subtitle ' + state.sub : '') + (n ? ', names ' + state.words.join(', ') : '') + ', score ' + state.score);
  }

  function update(fresh) { readForm(); relayout(fresh); draw(); saveHash(); }
  /* the typed-names timer has not fired yet: read the form now, so nothing acts on the text before the last keystroke */
  function flush() { clearTimeout(typeT); update(false); }

  function step(dir) {
    var list = choices();
    if (list.length < 2) return;
    locked = true;
    pick = (pick + dir + list.length) % list.length;
    if (dir > 0 && pick === 0) { seed += 101; search.search(seed, 250, 2500); list = choices(); }
    state.layout = list[pick]; report(null); draw(); saveHash();
  }

  /* shareable design link: everything needed to redraw this exact frame */
  function designCode() {
    return encodeDesign({ v: state.legacy ? 1 : 2, f: state.frame, b: state.bg, t: titleEl.value.trim(), s: subEl.value.trim(), n: state.typed, l: state.layout ? state.layout.place : null });
  }
  function designUrl() { return CFG.pageUrl + '#xw=' + designCode(); }
  /* The names never go into the address bar while someone types (analytics read it); a link is built just for the
     PDF and the cart line. The draft lives in this tab only (sessionStorage): a reload keeps it, a new visit starts
     clean (Murat, 2026-09-28; the old localStorage draft is removed). */
  var saveT = 0, DRAFT = 'asc-xw-draft';
  try { localStorage.removeItem(DRAFT); } catch (e) {}
  function saveHash() {
    clearTimeout(saveT);
    saveT = setTimeout(function () { try { sessionStorage.setItem(DRAFT, designCode()); } catch (e) {} }, 500);
  }
  /* #xw=<design> opens a saved design; #atolye=<key> unlocks the workshop SVG once in this browser; #o=ASC1234 fills
     the order number. The fragment never reaches the server and is removed from the address bar right away. */
  var FRAG = {};
  location.hash.replace(/^#/, '').split('&').forEach(function (kv) { var i = kv.indexOf('='); if (i > 0) { try { FRAG[kv.slice(0, i)] = decodeURIComponent(kv.slice(i + 1)); } catch (e) {} } });
  if (FRAG.xw || FRAG.atolye || FRAG.o) { try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {} }
  function loadHash() {
    var code = /^[A-Za-z0-9_-]+$/.test(FRAG.xw || '') ? FRAG.xw : null;
    if (!code) { try { code = sessionStorage.getItem(DRAFT); } catch (e) {} }
    if (!code) return false;
    try {
      var d = JSON.parse(unb64(code));
      if (d.f) { var fr = form.querySelector('input[name="xw-frame"][value="' + d.f + '"]'); if (fr) fr.checked = true; }
      if (d.b) { var br = form.querySelector('input[name="xw-bg"][value="' + d.b + '"]'); if (br) br.checked = true; }
      if (typeof d.t === 'string') titleEl.value = d.t.slice(0, 60);
      /* v1 links were made with the A-Z-only rule: keep it for them, so an order placed then reopens exactly */
      state.legacy = d.v === 1;
      if (typeof d.s === 'string') subEl.value = d.s.slice(0, 60);
      if (d.n && d.n.length) namesEl.value = d.n.join('\n');

      readForm(); relayout(true);
      var v = validate(state.words, d.l);
      if (v) { search.best.unshift(v); pick = 0; state.layout = v; locked = true; report(null); }
      return true;
    } catch (e) { return false; }
  }

  /* ---- PDF: a US Letter sheet with the logo, the frame (watermarked) and the choices ---- */
  function loadImg(src) {
    return new Promise(function (res) { if (!src) return res(null); var i = new Image(); i.crossOrigin = 'anonymous'; i.onload = function () { res(i); }; i.onerror = function () { res(null); }; i.src = src; });
  }
  function wrapText(x, text, maxW) {
    var words = text.split(' '), lines = [], line = '';
    words.forEach(function (w) { var t = line ? line + ' ' + w : w; if (x.measureText(t).width > maxW && line) { lines.push(line); line = w; } else line = t; });
    if (line) lines.push(line);
    return lines;
  }
  function makePdf() {
    pdfBtn.disabled = true; var lbl = pdfBtn.querySelector('span') || pdfBtn, label = lbl.textContent; lbl.textContent = 'Preparing PDF…';
    return loadImg(CFG.logo).then(function (logo) {
      var DPI = 250, PW = 8.5, PH = 11, W = Math.round(PW * DPI), H = Math.round(PH * DPI), mm = DPI / 25.4;
      var c = canvas(W, H), x = c.getContext('2d');
      x.fillStyle = '#ffffff'; x.fillRect(0, 0, W, H);
      var M = 16 * mm;
      if (logo) { var lh = 6.5 * mm, lw = lh * logo.naturalWidth / logo.naturalHeight; x.drawImage(logo, M, M, lw, lh); }
      x.fillStyle = '#6b645c'; x.font = '500 ' + (3.4 * mm) + 'px ' + F_TITLE; x.textAlign = 'right'; x.textBaseline = 'alphabetic';
      x.fillText('YOUR CROSSWORD FRAME PREVIEW', W - M, M + 5.4 * mm);
      x.strokeStyle = '#e4ded3'; x.lineWidth = 0.3 * mm; x.beginPath(); x.moveTo(M, M + 11 * mm); x.lineTo(W - M, M + 11 * mm); x.stroke();
      /* frame, real proportions, 140 mm wide on the sheet */
      var fw = 140, s = fw * mm / GEO.outer, fx = (W - fw * mm) / 2, fy = M + 18 * mm;
      x.save(); x.shadowColor = 'rgba(40,28,16,.28)'; x.shadowBlur = 6 * mm; x.shadowOffsetY = 2.5 * mm;
      x.fillStyle = '#222'; x.fillRect(fx, fy, fw * mm, fw * mm); x.restore();
      drawFrame(x, fx, fy, s, Object.assign({}, state, { ghostTitle: '', ghostSub: '' }));
      /* watermark over the frame only */
      x.save(); x.beginPath(); x.rect(fx, fy, fw * mm, fw * mm); x.clip();
      x.translate(fx + fw * mm / 2, fy + fw * mm / 2); x.rotate(-Math.PI / 6);
      x.font = '500 ' + (8 * mm) + 'px ' + F_TITLE; x.textAlign = 'center';
      for (var gy = -5; gy <= 5; gy++) for (var gx = -3; gx <= 3; gx++) {
        var tx = gx * 62 * mm + (gy % 2 ? 31 * mm : 0), ty = gy * 26 * mm;
        x.fillStyle = 'rgba(255,255,255,.10)'; x.fillText('ASC GIFTS', tx + 0.4 * mm, ty + 0.4 * mm);
        x.fillStyle = 'rgba(60,50,40,.10)'; x.fillText('ASC GIFTS', tx, ty);
      }
      x.restore();
      /* details */
      var y = fy + fw * mm + 12 * mm, colW = (W - 2 * M - 10 * mm) / 2, t = tier(state.words.length);
      function row(label, value, cx, yy, w) {
        x.textAlign = 'left'; x.fillStyle = '#8a8178'; x.font = '500 ' + (2.7 * mm) + 'px ' + F_TITLE; x.fillText(label.toUpperCase(), cx, yy);
        x.fillStyle = '#231b15'; x.font = '500 ' + (3.6 * mm) + 'px ' + F_TITLE;
        var lines = wrapText(x, value, w); lines.slice(0, 4).forEach(function (ln, i) { x.fillText(ln, cx, yy + (4.8 + i * 4.6) * mm); });
        return yy + (4.8 + (Math.min(lines.length, 4) - 1) * 4.6 + 6.4) * mm;
      }
      var yL = y, yR = y;
      yL = row('Frame', state.frame, M, yL, colW);
      yL = row('Background', state.bg, M, yL, colW);
      yL = row('Title', cleanTitle(titleEl.value) || 'No title', M, yL, colW);
      yL = row('Subtitle', cleanTitle(subEl.value) || 'No subtitle', M, yL, colW);
      var rx = M + colW + 10 * mm;
      yR = row('Names (' + state.words.length + ')', state.typed.join(', '), rx, yR, colW);
      yR = row('Score', String(state.score), rx, yR, colW);
      yR = row('Size', t.label + ' · ' + money(CFG.product.price + addCents(t)), rx, yR, colW);
      /* footer */
      var fy2 = H - M - 9 * mm;
      x.strokeStyle = '#e4ded3'; x.beginPath(); x.moveTo(M, fy2 - 6 * mm); x.lineTo(W - M, fy2 - 6 * mm); x.stroke();
      x.textAlign = 'left'; x.fillStyle = '#231b15'; x.font = '500 ' + (3.6 * mm) + 'px ' + F_TITLE;
      x.fillText('Open this design again or order it: ascgifts.com/pages/family-name-crossword-generator', M, fy2);
      x.fillStyle = '#8a8178'; x.font = '500 ' + (2.9 * mm) + 'px ' + F_TITLE;
      wrapText(x, CFG.woodNote, W - 2 * M).forEach(function (ln, i) { x.fillText(ln, M, fy2 + (5.2 + i * 4.3) * mm); });
      return new Promise(function (res) { c.toBlob(function (b) { res(b); }, 'image/jpeg', 0.9); }).then(function (blob) { return blob.arrayBuffer(); }).then(function (buf) {
        var pt = 72, linkY = (PH * DPI - fy2) / DPI * pt;
        var bytes = pdfBytes(new Uint8Array(buf), W, H, PW * pt, PH * pt, { url: designUrl(), rect: [M / DPI * pt, linkY - 6, (W - M) / DPI * pt, linkY + 12] }, 'Crossword frame preview - ASC Gifts');
        var a = document.createElement('a'), url = URL.createObjectURL(new Blob([bytes], { type: 'application/pdf' }));
        var nm = (legacyClean(titleEl.value) || 'family').toLowerCase().slice(0, 24);
        a.href = url; a.download = 'ascgifts-crossword-' + nm + '.pdf'; document.body.appendChild(a); a.click(); a.remove();
        setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
      });
    }).catch(function () { statusEl.textContent = 'The PDF could not be made in this browser. Please try again, or use another browser.'; })
      .then(function () { lbl.textContent = label; pdfBtn.disabled = false; });
  }

  /* ---- Final review and add to cart (2026-10-05, UX review) ----
     "Review your frame" freezes the design into a snapshot: names, tile words, colours, title and subtitle as typed,
     the chosen layout, product, tier, price and the edit target. The review draws the snapshot, and the cart line
     (properties and _Crossword design) is made from the same snapshot, so what is reviewed is what is ordered; a later
     refine pass, the title examples or a font that arrives late cannot change it. The line is the same one the product
     page's builder makes (option names, tier price through the builder's price fields). */
  var rv = el.querySelector('[data-xw-review]'), snap = null, zoom = 1, ZOOMS = [1, 1.5, 2.25, 3], opener = null, scrollY0 = 0, ignorePop = false, rvDrawT = 0;
  function q(sel) { return rv ? rv.querySelector(sel) : null; }
  var rvCv = q('[data-xw-rv-canvas]'), rvBox = q('[data-xw-rv-box]'), rvBuy = q('[data-xw-rv-buy]'), rvEdit = q('[data-xw-rv-edit]'), rvClose = q('[data-xw-rv-close]'),
      rvStatus = q('[data-xw-rv-status]'), rvIn = q('[data-xw-rv-in]'), rvOut = q('[data-xw-rv-out]'), rvReset = q('[data-xw-rv-reset]'), rvHead = q('[data-xw-rv-h]');
  function rvSet(name, text) { var n = q('[data-xw-rv="' + name + '"]'); if (n) n.textContent = text; return n; }

  function propsOf(s) {
    var t = s.tier, props = { 'Frame Color': s.frame, 'Background Color': s.bg, 'Number of Names': t.cart || t.label };
    props['Title'] = cleanTitle(s.tRaw) || 'None';
    props['Subtitle'] = cleanTitle(s.sRaw) || 'None';
    props['Names'] = s.typed.join(', ');
    props['_Crossword design'] = CFG.pageUrl + '#xw=' + s.code;
    props._cl_options = CFG.configId;
    if (t.add > 0) {
      props._cl_options_id = String(Date.now()); props._cl_options_price = String(addCents(t)); props._cl_options_currency = cur(); props._cl_options_price_base = String(Math.round(t.add * 100));
      var json = {}; Object.keys(props).forEach(function (k) { if (k !== '_Crossword design') json[k] = props[k]; });
      props._cl_options_json = JSON.stringify(json);
    }
    return props;
  }
  function takeSnapshot() {
    var n = state.words.length, lay = state.layout, over = lastParsed && lastParsed.notes.over.length;
    if (state.example || n < 2 || !lay || lay.missing.length || over) return null;
    var place = lay.place.map(function (p) { return p ? p.slice() : p; }), v = validate(state.words, place);
    if (!v) return null;
    var t = tier(n), s = {
      v: state.legacy ? 1 : 2, frame: state.frame, bg: state.bg, tRaw: titleEl.value.trim(), sRaw: subEl.value.trim(),
      typed: state.typed.slice(), words: state.words.slice(), layout: v, score: totalScore(state.words), tier: t,
      price: CFG.product.price + addCents(t), variant: CFG.product.variant, editKey: editKey, editQty: editQty
    };
    s.code = encodeDesign({ v: s.v, f: s.frame, b: s.bg, t: s.tRaw, s: s.sRaw, n: s.typed, l: place });
    s.props = propsOf(s);
    return s;
  }
  function sceneOfSnap(s) {
    return { frame: s.frame, bg: s.bg, title: s.tRaw.toLocaleUpperCase('en-US'), sub: s.sRaw.toLocaleUpperCase('en-US'), score: s.score, words: s.words, layout: s.layout, example: false };
  }

  /* the review canvas: drawn from the snapshot only when it opens or the zoom changes (no animation loop), backing
     store capped at 2400 px */
  function drawReview() {
    if (!snap || !rvCv || !rvBox) return;
    cancelAnimationFrame(rvDrawT);
    rvDrawT = requestAnimationFrame(function () {
      var w = rvBox.clientWidth || 360, dpr = Math.min(root.devicePixelRatio || 1, 2), px = Math.min(2400, Math.round(w * zoom * dpr));
      rvCv.style.width = (zoom * 100) + '%';
      if (rvCv.width !== px) { rvCv.width = px; rvCv.height = px; }
      try { drawScene(rvCv, sceneOfSnap(snap)); rvBox.classList.remove('is-loading'); }
      catch (e) { rvBox.classList.remove('is-loading'); }
    });
  }
  function setZoom(z) {
    if (!rvBox) return;
    var cx = (rvBox.scrollLeft + rvBox.clientWidth / 2) / (rvBox.scrollWidth || 1), cy = (rvBox.scrollTop + rvBox.clientHeight / 2) / (rvBox.scrollHeight || 1);
    zoom = z;
    rvCv.style.width = (zoom * 100) + '%';
    rvBox.scrollLeft = cx * rvBox.scrollWidth - rvBox.clientWidth / 2; rvBox.scrollTop = cy * rvBox.scrollHeight - rvBox.clientHeight / 2;
    var i = ZOOMS.indexOf(zoom);
    if (rvOut) rvOut.disabled = i <= 0; if (rvIn) rvIn.disabled = i >= ZOOMS.length - 1; if (rvReset) rvReset.disabled = zoom === 1;
    rvBox.classList.toggle('is-zoomed', zoom > 1);
    drawReview();
  }
  function fillReview(s) {
    var tl = cleanTitle(s.tRaw), sl = cleanTitle(s.sRaw);
    rvSet('frame', s.frame); rvSet('bg', s.bg);
    rvSet('title', tl || 'Not added').classList.toggle('is-none', !tl);
    rvSet('sub', sl || 'Not added').classList.toggle('is-none', !sl);
    rvSet('count', String(s.words.length));
    rvSet('names', s.words.join(' · '));
    rvSet('size', s.tier.label);
    rvSet('price', money(s.price));
    var qn = rvSet('qty', s.editKey && s.editQty > 1 ? s.editQty + ' frames · ' + money(s.price) + ' each' : '');
    if (qn) qn.parentNode.hidden = !(s.editKey && s.editQty > 1);
    if (rvBuy) { rvBuy.textContent = (s.editKey ? 'Update my frame · ' : 'Add to cart · ') + money(s.price); rvBuy.disabled = false; rvBuy.hidden = false; }
    var go = q('[data-xw-rv-cart]'); if (go) go.hidden = true;
    if (rvStatus) { rvStatus.textContent = ''; rvStatus.hidden = true; }
  }
  function openReview() {
    if (!rv || busy) return;
    var s = takeSnapshot();
    if (!s) { report(null); return; }
    snap = s;
    /* the shown layout is now the customer's: no refine pass may swap it after the review */
    locked = true; clearTimeout(refineT);
    opener = document.activeElement; if (!opener || opener === document.body || rv.contains(opener)) opener = cartBtn; scrollY0 = root.scrollY || 0;
    fillReview(s);
    zoom = 1; rvBox.classList.add('is-loading'); rvBox.scrollLeft = 0; rvBox.scrollTop = 0;
    document.documentElement.classList.add('at-xw-rv-open');
    if (rv.showModal) { if (!rv.open) rv.showModal(); } else rv.setAttribute('open', '');
    /* the phone's back button closes the review instead of leaving the page; same address, nothing personal in it */
    /* one entry at most, even when the review is opened again before the last back step has landed */
    if (!(history.state && history.state.xwReview)) { try { history.pushState({ xwReview: 1 }, '', location.href); } catch (e) {} }
    if (rvHead) rvHead.focus({ preventScroll: true });
    setZoom(1);
    var fontWait = fontsReady ? Promise.resolve() : Promise.race([fontsP, new Promise(function (r) { setTimeout(r, 2500); })]);
    fontWait.then(drawReview);
    track('xw_review_opened', { names: s.words.length, tier: s.tier.max, edit: !!s.editKey });
  }
  function closeReview(fromPop) {
    if (!rv || busy) return;
    cancelAnimationFrame(rvDrawT);
    if (rv.open) { if (rv.close) rv.close(); else rv.removeAttribute('open'); }
    document.documentElement.classList.remove('at-xw-rv-open');
    if (!fromPop && history.state && history.state.xwReview) { ignorePop = true; try { history.back(); } catch (e) { ignorePop = false; } }
    snap = null;
    root.scrollTo(0, scrollY0);
    if (opener && opener.focus) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
  }

  function setBusy(on, label) {
    busy = on;
    if (rvBuy) { rvBuy.disabled = on; if (label) rvBuy.textContent = label; }
    if (rvEdit) rvEdit.disabled = on; if (rvClose) rvClose.disabled = on;
    if (rv) rv.setAttribute('aria-busy', on ? 'true' : 'false');
    cartBtn.disabled = on;
    if (!on) report(null);
  }
  function fail(code, msg, cartLink) {
    var e = new Error(code); e.code = code; e.msg = msg; e.cartLink = !!cartLink; return e;
  }
  var MSG = {
    network: 'We couldn’t reach the store. Please check your connection and try again.',
    refused: 'We couldn’t add your frame. Please try again in a moment, or message us and we’ll help.',
    busy: 'Too many tries in a short time. Please wait a few seconds and try again.',
    uncertain: 'We couldn’t confirm whether your frame was added. Please open your cart to check before trying again.',
    remove_old: 'Your updated frame is in your cart, but the old one is still there too. Please remove the old frame in your cart.'
  };
  function showFail(e) {
    var code = e && e.code || 'error';
    setBusy(false);
    if (rvStatus) { rvStatus.textContent = e && e.msg || MSG.refused; rvStatus.hidden = false; }
    /* an unknown result is never sent again from here: the way on is the cart */
    if (e && e.cartLink) { var go = q('[data-xw-rv-cart]'); if (go) go.hidden = false; if (rvBuy) rvBuy.hidden = true; }
    else if (rvBuy && snap) rvBuy.textContent = 'Try again · ' + money(snap.price);
    track('xw_add_failed', { code: code, edit: !!(snap && snap.editKey) });
  }

  function buy() {
    if (!snap || busy) return;
    var s = snap, base = root.Shopify && root.Shopify.routes && root.Shopify.routes.root || '/', JSONH = { 'Content-Type': 'application/json', Accept: 'application/json' };
    var newC = canon(s.props), oldC = null, baseline = 0, known = false;
    setBusy(true, s.editKey ? 'Updating…' : 'Adding…');
    if (rvStatus) { rvStatus.textContent = ''; rvStatus.hidden = true; }
    function getCart() { return fetch(base + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); }); }
    /* 1. the cart before: how many of this exact line already exist (to read an unknown answer), and in an edit the
       old line, found by its key or by the design it was opened with (keys change with the bulk discount) */
    getCart().then(function (c) {
      var items = c.items || [];
      baseline = lineQty(items, newC); known = true;
      if (s.editKey) {
        items.forEach(function (it) { if (!oldC && it.key === s.editKey) oldC = canon(it.properties); });
        if (!oldC && FRAG.xw) items.forEach(function (it) {
          var d = it.properties && it.properties['_Crossword design'];
          if (!oldC && d && d.slice(-(FRAG.xw.length + 4)) === '#xw=' + FRAG.xw) oldC = canon(it.properties);
        });
      }
    }, function () { if (s.editKey) throw fail('network', MSG.network); })
    /* 2. the one add request */
      .then(function () {
        return fetch(base + 'cart/add.js', { method: 'POST', headers: JSONH, body: JSON.stringify({ items: [{ id: s.variant, quantity: s.editKey ? s.editQty : 1, properties: s.props }] }) })
          .then(function (r) { return r.text().then(function (txt) { var j = null; try { j = JSON.parse(txt); } catch (e) {} return { status: r.status, body: j }; }); },
                function () { return { status: 0, body: null }; });
      })
      .then(function (res) {
        var out = addOutcome(res.status, res.body);
        if (out === 'refused') throw fail(res.status === 429 ? 'busy' : 'refused_' + res.status, res.status === 429 ? MSG.busy : MSG.refused);
        if (out === 'ok') return null;
        /* unknown: read the cart instead of sending again */
        return getCart().then(function (c) {
          if (known && lineQty(c.items, newC) > baseline) return null;
          /* the cart shows it did not go in: safe to try again */
          if (known) throw fail('network', MSG.network);
          throw fail('uncertain', MSG.uncertain, true);
        }, function () { throw fail('uncertain', MSG.uncertain, true); });
      })
    /* 3. an edit: take the old line away (or back to its quantity when the design did not change) and check it */
      .then(function () {
        if (!s.editKey) return null;
        return getCart().then(function (c) {
          var plan = planEdit(c.items, oldC, newC, s.editQty);
          if (plan.op === 'none') return c;
          return fetch(base + 'cart/change.js', { method: 'POST', headers: JSONH, body: JSON.stringify({ id: plan.key, quantity: plan.qty }) })
            .then(function (r) { if (!r.ok) throw new Error('change ' + r.status); return r.json(); })
            .then(function (c2) {
              var left = lineQty(c2.items, oldC);
              if (oldC !== newC && left > 0) throw new Error('old line kept');
              if (oldC === newC && left !== s.editQty) throw new Error('quantity');
              return c2;
            });
        }).catch(function (e) { if (e && e.code) throw e; throw fail('remove_old', MSG.remove_old, true); });
      })
      .then(function (c) {
        /* the new line's key, so a second edit after the back button replaces this line */
        if (s.editKey && c && c.items) c.items.forEach(function (it) {
          if (canon(it.properties) === newC) { editKey = it.key; try { var sp = new URLSearchParams(location.search); sp.set('edit', editKey); history.replaceState(history.state, '', location.pathname + '?' + sp.toString()); } catch (e) {} }
        });
        try { document.dispatchEvent(new CustomEvent('asc:xw-added', { detail: { names: s.words.length, tier: s.tier.label, edit: !!s.editKey } })); } catch (e) {}
        track('xw_add_succeeded', { names: s.words.length, tier: s.tier.max, edit: !!s.editKey });
        /* the page is left as it should come back (Safari's back button restores it as it was left) */
        busy = false; if (rvBuy) rvBuy.disabled = false;
        if (rv && rv.open) { if (rv.close) rv.close(); else rv.removeAttribute('open'); }
        document.documentElement.classList.remove('at-xw-rv-open');
        snap = null; report(null);
        root.location.href = base + 'cart';
      })
      .catch(showFail);
  }

  /* the main button: never a cart request */
  function primary() {
    if (busy) return;
    /* 2026-10-08: Clarity only keeps the event name, so the button state is part of it (names, more, fix, review) */
    track('xw_cta_' + ctaMode, {}, { once: ctaMode });
    flush();
    if (ctaMode === 'review') { openReview(); return; }
    showStep('names');
    var target = ctaMode === 'fix' && !alertEl.hidden ? alertEl : namesEl;
    target.scrollIntoView({ block: 'center', behavior: REDUCED ? 'auto' : 'smooth' });
    try { namesEl.focus({ preventScroll: true }); var L = namesEl.value.length; namesEl.setSelectionRange(L, L); } catch (e) {}
  }
  if (rv) {
    if (rvBuy) rvBuy.addEventListener('click', buy);
    if (rvClose) rvClose.addEventListener('click', function () { closeReview(false); });
    if (rvEdit) rvEdit.addEventListener('click', function () { track('xw_review_edit', { edit: !!editKey }); closeReview(false); });
    if (rvIn) rvIn.addEventListener('click', function () { var i = ZOOMS.indexOf(zoom); if (i < ZOOMS.length - 1) setZoom(ZOOMS[i + 1]); });
    if (rvOut) rvOut.addEventListener('click', function () { var i = ZOOMS.indexOf(zoom); if (i > 0) setZoom(ZOOMS[i - 1]); });
    if (rvReset) rvReset.addEventListener('click', function () { setZoom(1); });
    /* Escape: closes, except while the cart request is out */
    rv.addEventListener('cancel', function (e) { e.preventDefault(); if (!busy) closeReview(false); });
    /* a click on the dimmed backdrop (outside the box) closes too */
    rv.addEventListener('click', function (e) { if (e.target === rv && !busy) closeReview(false); });
    root.addEventListener('popstate', function () {
      if (ignorePop) {
        ignorePop = false;
        /* the review was opened again while that back step was on its way: give it its entry back */
        if (rv.open && !(history.state && history.state.xwReview)) { try { history.pushState({ xwReview: 1 }, '', location.href); } catch (e) {} }
        return;
      }
      if (rv.open) { if (busy) { try { history.pushState({ xwReview: 1 }, '', location.href); } catch (e) {} return; } closeReview(true); }
    });
    root.addEventListener('resize', function () { if (rv.open) drawReview(); });
  }

  /* ---- symbols for the title and subtitle: the picker inserts the character at the caret of the last used field ---- */
  var symTarget = titleEl;
  function symLabel() { if (symTargetEl) symTargetEl.textContent = symTarget === subEl ? 'Adds to the subtitle' : 'Adds to the title'; }
  [titleEl, subEl].forEach(function (f) { f.addEventListener('focus', function () { symTarget = f; symLabel(); }); });
  symLabel();
  if (symGrid) {
    symGrid.innerHTML = ICONS.map(function (ic) {
      return '<button type="button" class="at-xw__symbtn" data-sym="' + ic.c + '" aria-label="' + ic.n + '" title="' + ic.n + '"><svg viewBox="0 0 256 256" aria-hidden="true"><path d="' + ic.d + '"/></svg></button>';
    }).join('');
    symGrid.addEventListener('click', function (e) {
      var b = e.target.closest('[data-sym]'); if (!b) return;
      var f = symTarget, ch = b.getAttribute('data-sym'), v = f.value, max = +f.getAttribute('maxlength') || 60;
      if (v.length + ch.length > max) { noteEl.hidden = false; noteEl.textContent = 'That line is full. Remove a few characters to add a symbol.'; return; }
      var a = f.selectionStart == null ? v.length : f.selectionStart, z = f.selectionEnd == null ? v.length : f.selectionEnd;
      var pre = v.slice(0, a), post = v.slice(z);
      var ins = (pre && !/\s$/.test(pre) ? ' ' : '') + ch + (post && !/^\s/.test(post) ? ' ' : '');
      if (v.length + ins.length > max) ins = ch;
      f.value = pre + ins + post;
      f.focus(); try { f.setSelectionRange(pre.length + ins.length, pre.length + ins.length); } catch (err) {}
      update(false);
    });
  }
  if (symToggle) symToggle.addEventListener('click', function () {
    var open = symGrid.hidden; symGrid.hidden = !open; symToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---- workshop: laser SVG (Murat only). The SVG code is not in this file (2026-09-29): assets/asc-xw-ws.js holds it
     encrypted (AES-256-GCM, key derived from the workshop key with PBKDF2-SHA-256; source and build script in
     docs/tools/crossword-workshop/). A browser that opened the page once with #atolye=<key> keeps the key; there the
     page checks it against the SHA-256 in the config, loads the ciphertext, decrypts it, and only then shows the panel
     and wires the button. Anywhere else there is no code behind the button to run. ---- */
  var WSKEY = 'asc-xw-atolye';
  if (FRAG.atolye) { try { localStorage.setItem(WSKEY, FRAG.atolye); } catch (e) {} }
  function script(src, ready) {
    return new Promise(function (res, rej) {
      if (ready()) return res();
      var sc = document.createElement('script'); sc.src = src; sc.onload = res; sc.onerror = function () { rej(new Error('could not load ' + src.split('/').pop().split('?')[0])); }; document.head.appendChild(sc);
    });
  }
  function u8(s) { var bin = atob(s), u = new Uint8Array(bin.length); for (var i = 0; i < bin.length; i++) u[i] = bin.charCodeAt(i); return u; }
  function wsNote(t) { var n = el.querySelector('[data-xw-wsnote]'); if (n) { n.textContent = t; n.hidden = !t; } }
  (function unlock() {
    var k = null; try { k = localStorage.getItem(WSKEY); } catch (e) {}
    var W = CFG.workshop, subtle = root.crypto && root.crypto.subtle;
    if (!k || !wsEl || !svgBtn || !W || !W.hash || !W.code || !subtle || !root.TextEncoder) return;
    var enc = new TextEncoder();
    subtle.digest('SHA-256', enc.encode(k)).then(function (b) {
      var h = Array.from(new Uint8Array(b)).map(function (v) { return v.toString(16).padStart(2, '0'); }).join('');
      if (h !== W.hash) throw new Error('not the workshop key');
      return script(W.code, function () { return !!root.ASCXW_WS; });
    }).then(function () {
      var P = root.ASCXW_WS;
      return subtle.importKey('raw', enc.encode(k), 'PBKDF2', false, ['deriveKey']).then(function (base) {
        return subtle.deriveKey({ name: 'PBKDF2', salt: u8(P.salt), iterations: P.iter, hash: 'SHA-256' }, base, { name: 'AES-GCM', length: 256 }, false, ['decrypt']);
      }).then(function (key) { return subtle.decrypt({ name: 'AES-GCM', iv: u8(P.iv) }, key, u8(P.ct)); });
    }).then(function (buf) {
      var ws = new Function('api', new TextDecoder().decode(buf))({
        root: root, state: state, GEO: GEO, gridBox: gridBox, tileCells: tileCells, tileValue: tileValue, layoutLine: layoutLine,
        titleTokens: titleTokens, esc: esc, CFG: CFG, script: script, orderEl: orderEl, svgBtn: svgBtn, wsNote: wsNote
      });
      svgBtn.addEventListener('click', function () { ws.makeSvg(); });
      wsEl.hidden = false;
      if (FRAG.o) orderEl.value = FRAG.o.toUpperCase().replace(/^#/, '');
      /* the order e-mail's link ends in &dl=1: download the SVG straight away */
      if (FRAG.dl && FRAG.xw) setTimeout(function () { wsEl.scrollIntoView({ block: 'center' }); ws.makeSvg(); }, 400);
    }).catch(function () { /* no key, a wrong key or a failed load: the panel stays hidden */ });
  })();


  /* ---- typing examples in the empty title and subtitle (and faintly on the preview) ---- */
  var REDUCED = root.matchMedia && root.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function ghost(input, key) {
    var span = el.querySelector('[data-xw-ghost="' + key + '"]');
    if (!span) return;
    var list = (span.getAttribute('data-examples') || '').split('|').map(function (t) { return t.trim(); }).filter(Boolean);
    if (!list.length) return;
    var i = 0, pos = 0, phase = 'type', timer = 0, stateKey = key === 'title' ? 'ghostTitle' : 'ghostSub';
    function show(txt) { span.textContent = txt; }
    function preview(txt) { var up = txt.toLocaleUpperCase('en-US'); if (state[stateKey] !== up) { state[stateKey] = up; if (!input.value.trim()) draw(); } }
    function idle() { return !input.value && document.activeElement !== input; }
    function tick() {
      clearTimeout(timer);
      if (!idle()) { span.hidden = true; return; }
      span.hidden = false;
      var chars = Array.from(list[i]);
      if (phase === 'type') {
        pos++; show(chars.slice(0, pos).join(''));
        if (pos >= chars.length) { phase = 'hold'; preview(list[i]); timer = setTimeout(tick, 1900); return; }
        timer = setTimeout(tick, 70 + Math.random() * 40);
      } else if (phase === 'hold') { phase = 'erase'; timer = setTimeout(tick, 30); }
      else {
        pos--; show(chars.slice(0, Math.max(pos, 0)).join(''));
        if (pos <= 0) { phase = 'type'; i = (i + 1) % list.length; timer = setTimeout(tick, 380); return; }
        timer = setTimeout(tick, 32);
      }
    }
    function restart() { clearTimeout(timer); if (!idle()) { span.hidden = true; return; } span.hidden = false; if (REDUCED) { show(list[0]); preview(list[0]); return; } phase = 'type'; pos = 0; timer = setTimeout(tick, 400); }
    input.setAttribute('aria-label', (key === 'title' ? 'Title' : 'Subtitle') + ', for example ' + list[0]);
    input.addEventListener('focus', function () { clearTimeout(timer); span.hidden = true; input.placeholder = list[i] || list[0]; });
    input.addEventListener('blur', function () { input.placeholder = ''; restart(); });
    input.addEventListener('input', function () { if (input.value) { clearTimeout(timer); span.hidden = true; } });
    state[stateKey] = list[0].toLocaleUpperCase('en-US');
    restart();
  }
  ghost(titleEl, 'title');
  ghost(subEl, 'sub');

  /* ---- phones: the preview sticks under the header; when the keyboard is open it shrinks and the bar hides ---- */
  document.documentElement.classList.add('at-xw-page');
  var UI = (/[?&]ui=([ab])/.exec(location.search) || [])[1] || el.getAttribute('data-ui') || 'a';
  el.classList.remove('at-xw--ui-a', 'at-xw--ui-b'); el.classList.add('at-xw--ui-' + UI);
  var mq = root.matchMedia ? root.matchMedia('(max-width: 899px)') : { matches: false };
  function headerBottom() {
    var h = document.querySelector('.sticky-header') || document.querySelector('header');
    if (!h) return 0;
    var cs = getComputedStyle(h), r = h.getBoundingClientRect();
    return (cs.position === 'fixed' || cs.position === 'sticky') && r.bottom > 0 ? Math.round(r.bottom) : 0;
  }
  var lastTop = -1;
  function place() {
    if (!mq.matches) return;
    var t = headerBottom();
    if (t !== lastTop) { lastTop = t; el.style.setProperty('--xw-top', t + 'px'); }
  }
  function keyboard() {
    var vv = root.visualViewport;
    var open = mq.matches && vv && (root.innerHeight - vv.height > 140) && /^(INPUT|TEXTAREA)$/.test((document.activeElement || {}).tagName || '');
    el.classList.toggle('at-xw--kb', !!open);
  }
  /* the mini preview (2026-09-29): once most of the in-page preview has scrolled away the stage floats at the top
     (css .at-xw--mini, position fixed, so nothing below moves; the box keeps the preview's height meanwhile). It goes
     back when the preview comes into view again, and it steps aside once the form has scrolled past. */
  var stageBox = el.querySelector('[data-xw-stagebox]'), mini = false;
  function miniCheck() {
    var want = false;
    if (mq.matches && stageBox) {
      var r = stageBox.getBoundingClientRect(), h = r.height || 1;
      want = mini ? r.bottom < h * 0.5 : r.bottom < h * 0.35;
      /* it stays while any of the form is below it (the title fields come last) */
      if (form.getBoundingClientRect().bottom < root.innerHeight * 0.3 + 70) want = false;
    }
    if (want === mini) return;
    if (want) stageBox.style.height = stageBox.offsetHeight + 'px';
    mini = want; el.classList.toggle('at-xw--mini', want);
    if (!want) stageBox.style.height = '';
  }
  root.addEventListener('scroll', function () { place(); miniCheck(); }, { passive: true });
  if (root.visualViewport) root.visualViewport.addEventListener('resize', function () { keyboard(); place(); });
  form.addEventListener('focusin', function () { setTimeout(keyboard, 350); });
  form.addEventListener('focusout', function () { setTimeout(keyboard, 150); });
  place();

  /* ---- ui b: one step at a time ---- */
  function showStep(name) {
    if (!tabsEl) return;
    Array.prototype.forEach.call(tabsEl.querySelectorAll('[data-tab]'), function (b) { b.setAttribute('aria-selected', b.getAttribute('data-tab') === name ? 'true' : 'false'); });
    Array.prototype.forEach.call(form.querySelectorAll('[data-step]'), function (s) { s.classList.toggle('is-on', s.getAttribute('data-step') === name); });
  }
  if (tabsEl) {
    tabsEl.addEventListener('click', function (e) { var b = e.target.closest('[data-tab]'); if (b) showStep(b.getAttribute('data-tab')); });
    form.addEventListener('click', function (e) { var b = e.target.closest('[data-next]'); if (b) { showStep(b.getAttribute('data-next')); tabsEl.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } });
    /* 2026-10-05: names first in both phone layouts */
    showStep('names');
  }
  chipEl.addEventListener('click', function () {
    var st = chipEl.getAttribute('data-state');
    if (st === 'ok') return;
    showStep('names');
    if (st === 'warn') alertEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    else namesEl.focus();
  });

  /* ---- swipe the preview to change the layout ---- */
  (function () {
    var wrap = el.querySelector('[data-xw-swipe]'), x0 = null, y0 = 0;
    if (!wrap || !root.PointerEvent) return;
    wrap.addEventListener('pointerdown', function (e) { if (e.target.closest('button')) return; x0 = e.clientX; y0 = e.clientY; });
    wrap.addEventListener('pointerup', function (e) {
      if (x0 === null) return;
      var dx = e.clientX - x0, dy = e.clientY - y0; x0 = null;
      if (Math.abs(dx) > 45 && Math.abs(dy) < 40) step(dx < 0 ? 1 : -1);
    });
    wrap.addEventListener('pointercancel', function () { x0 = null; });
  })();

  /* ---- wiring ---- */
  var typeT = 0;
  form.addEventListener('input', function (e) {
    if (e.target === namesEl) {
      state.legacy = false; clearTimeout(typeT); typeT = setTimeout(function () { update(false); }, 160);
      if (namesEl.value.trim()) track('xw_started', { edit: !!editKey }, { once: true });
      return;
    }
    if (e.target === orderEl) return;
    update(false);
  });
  form.addEventListener('change', function (e) { if (e.target.name === 'xw-frame' || e.target.name === 'xw-bg') update(false); });
  /* Enter in a field never submits anything: the cart request lives only in the final review */
  form.addEventListener('submit', function (e) { e.preventDefault(); });
  /* 2026-10-08: the phone keyboard's "next" key moves from Title to Subtitle and "done" closes the keyboard, so the
     buy bar (hidden while the keyboard is open) comes back. With no submit button, Enter did nothing in these fields. */
  form.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || e.isComposing) return;
    if (titleEl && e.target === titleEl) { e.preventDefault(); if (subEl) subEl.focus(); }
    else if (subEl && e.target === subEl) { e.preventDefault(); subEl.blur(); }
  });
  cartBtn.addEventListener('click', primary);
  /* back-button restore (bfcache): no request is out any more, the review is closed, the buttons match the form */
  root.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    busy = false; snap = null;
    if (rv && rv.open) { if (rv.close) rv.close(); else rv.removeAttribute('open'); }
    document.documentElement.classList.remove('at-xw-rv-open');
    update(false);
  });
  /* "How pricing works": the three tiers from the product price and the tier add-ons, in the shopper's currency */
  if (tiersEl) tiersEl.textContent = CFG.tiers.map(function (t) { return t.label + ': ' + money(CFG.product.price + addCents(t)); }).join(' · ') + '.';
  nextBtn.addEventListener('click', function () { step(1); });
  prevBtn.addEventListener('click', function () { step(-1); });
  pdfBtn.addEventListener('click', function () { track('xw_pdf', {}, { once: true }); if (fontsReady) makePdf(); else fontsP.then(makePdf); });

  var rsT = 0; root.addEventListener('resize', function () { clearTimeout(rsT); rsT = setTimeout(function () { draw(); paintSwatches(); miniCheck(); }, 120); });

  /* fonts: a slow or failed font never leaves the PDF or the review waiting (fallback stack after 4 s) */
  var fontsP = loadFonts(CFG.fonts, 4000, function () { fontsReady = true; draw(); if (rv && rv.open) drawReview(); });
  if (!loadHash()) update(true); else draw();
  fontsP.then(function () { fontsReady = true; draw(); });
  (root.requestIdleCallback || function (fn) { return setTimeout(fn, 200); })(boardTextures);
})(typeof window !== 'undefined' ? window : this);
